var Ps = Object.defineProperty;
var Cs = (e, t, r) => t in e ? Ps(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var xe = (e, t, r) => (Cs(e, typeof t != "symbol" ? t + "" : t, r), r);
import Yr, { useState as mr, useEffect as Zr, useCallback as xt } from "react";
import { toast as te } from "@systemeio/ui";
class Bs extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
class Qr extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
class kt extends Error {
  constructor(r) {
    super(r.detail);
    xe(this, "errors");
    this.errors = r, this.violationsTitleToMessage();
  }
  // TODO: delete this method after BE decide what to use title or message
  violationsTitleToMessage() {
    var r;
    (r = this.errors.violations) == null || r.forEach((n) => {
      "title" in n && (n.message = n.title, delete n.title);
    });
  }
}
class Kr extends Error {
  constructor(r) {
    var n;
    super((n = r.errors.common) == null ? void 0 : n.join(""));
    xe(this, "errors");
    this.errors = r.errors;
  }
  toErrorWithViolations({
    type: r,
    status: n,
    title: s,
    code: i
  }) {
    return new kt({
      type: r,
      status: n,
      title: s,
      detail: this.message,
      violations: this.flattenObjectToViolations(this.errors.fields, i, "")
    });
  }
  flattenObjectToViolations(r, n, s = "") {
    const i = [];
    return typeof r == "string" ? (i.push({ propertyPath: s, message: r, code: n }), i) : (Array.isArray(r) ? r.length === 1 ? i.push({ propertyPath: s, message: r[0], code: n }) : r.forEach((o, u) => {
      const c = `${s}[${u}]`;
      i.push(...this.flattenObjectToViolations(o, n, c));
    }) : r !== null && typeof r == "object" && Object.entries(r).forEach(([o, u]) => {
      const c = s ? `${s}.${o}` : o;
      i.push(...this.flattenObjectToViolations(u, n, c));
    }), i);
  }
}
class en extends Kr {
  toErrorWithViolations() {
    return super.toErrorWithViolations({
      type: "",
      status: Ve.code,
      title: "",
      code: Ve.code
    });
  }
}
class Ve extends kt {
}
xe(Ve, "code", 422);
class tn extends Kr {
}
class rn extends Error {
  constructor(t) {
    super(t), this.name = this.constructor.name;
  }
}
class nn extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
const Ns = [
  "Invalid JWT Token",
  "JWT Token not found",
  "Expired JWT Token"
];
class ga extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
class sn extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
class Hs extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
class Tt extends Error {
  constructor(t) {
    super(t == null ? void 0 : t.error.message), this.name = this.constructor.name;
  }
  static isNotFoundResponse(t) {
    return !(!t || typeof t != "object" || !("error" in t) || !t.error || typeof t.error != "object" || !("code" in t.error) || !("message" in t.error));
  }
}
class on extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
class an extends Error {
  constructor(r) {
    super(r);
    xe(this, "location");
    this.location = r;
  }
}
class un extends kt {
}
const ln = (e) => typeof e != "object" || Array.isArray(e) || e === null ? (console.error("field has wrong type"), !1) : Object.values(e).some(
  (t) => Array.isArray(t) ? t.length : ln(t)
);
function cn(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Is } = Object.prototype, { getPrototypeOf: jt } = Object, Xe = /* @__PURE__ */ ((e) => (t) => {
  const r = Is.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Q = (e) => (e = e.toLowerCase(), (t) => Xe(t) === e), ze = (e) => (t) => typeof t === e, { isArray: be } = Array, Re = ze("undefined");
function Ls(e) {
  return e !== null && !Re(e) && e.constructor !== null && !Re(e.constructor) && X(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const hn = Q("ArrayBuffer");
function Ds(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && hn(e.buffer), t;
}
const Fs = ze("string"), X = ze("function"), fn = ze("number"), Je = (e) => e !== null && typeof e == "object", Us = (e) => e === !0 || e === !1, Ue = (e) => {
  if (Xe(e) !== "object")
    return !1;
  const t = jt(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Ms = Q("Date"), ks = Q("File"), js = Q("Blob"), Gs = Q("FileList"), Vs = (e) => Je(e) && X(e.pipe), Ws = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || X(e.append) && ((t = Xe(e)) === "formdata" || // detect form-data instance
  t === "object" && X(e.toString) && e.toString() === "[object FormData]"));
}, $s = Q("URLSearchParams"), [qs, Xs, zs, Js] = ["ReadableStream", "Request", "Response", "Headers"].map(Q), Ys = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ae(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, s;
  if (typeof e != "object" && (e = [e]), be(e))
    for (n = 0, s = e.length; n < s; n++)
      t.call(null, e[n], n, e);
  else {
    const i = r ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let u;
    for (n = 0; n < o; n++)
      u = i[n], t.call(null, e[u], u, e);
  }
}
function dn(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, s;
  for (; n-- > 0; )
    if (s = r[n], t === s.toLowerCase())
      return s;
  return null;
}
const le = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, pn = (e) => !Re(e) && e !== le;
function St() {
  const { caseless: e } = pn(this) && this || {}, t = {}, r = (n, s) => {
    const i = e && dn(t, s) || s;
    Ue(t[i]) && Ue(n) ? t[i] = St(t[i], n) : Ue(n) ? t[i] = St({}, n) : be(n) ? t[i] = n.slice() : t[i] = n;
  };
  for (let n = 0, s = arguments.length; n < s; n++)
    arguments[n] && Ae(arguments[n], r);
  return t;
}
const Zs = (e, t, r, { allOwnKeys: n } = {}) => (Ae(t, (s, i) => {
  r && X(s) ? e[i] = cn(s, r) : e[i] = s;
}, { allOwnKeys: n }), e), Qs = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Ks = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, ei = (e, t, r, n) => {
  let s, i, o;
  const u = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (s = Object.getOwnPropertyNames(e), i = s.length; i-- > 0; )
      o = s[i], (!n || n(o, e, t)) && !u[o] && (t[o] = e[o], u[o] = !0);
    e = r !== !1 && jt(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, ti = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, ri = (e) => {
  if (!e)
    return null;
  if (be(e))
    return e;
  let t = e.length;
  if (!fn(t))
    return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, ni = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && jt(Uint8Array)), si = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let s;
  for (; (s = n.next()) && !s.done; ) {
    const i = s.value;
    t.call(e, i[0], i[1]);
  }
}, ii = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, oi = Q("HTMLFormElement"), ai = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, s) {
    return n.toUpperCase() + s;
  }
), br = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), ui = Q("RegExp"), mn = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  Ae(r, (s, i) => {
    let o;
    (o = t(s, i, e)) !== !1 && (n[i] = o || s);
  }), Object.defineProperties(e, n);
}, li = (e) => {
  mn(e, (t, r) => {
    if (X(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (X(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, ci = (e, t) => {
  const r = {}, n = (s) => {
    s.forEach((i) => {
      r[i] = !0;
    });
  };
  return be(e) ? n(e) : n(String(e).split(t)), r;
}, hi = () => {
}, fi = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, lt = "abcdefghijklmnopqrstuvwxyz", gr = "0123456789", bn = {
  DIGIT: gr,
  ALPHA: lt,
  ALPHA_DIGIT: lt + lt.toUpperCase() + gr
}, di = (e = 16, t = bn.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = t;
  for (; e--; )
    r += t[Math.random() * n | 0];
  return r;
};
function pi(e) {
  return !!(e && X(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const mi = (e) => {
  const t = new Array(10), r = (n, s) => {
    if (Je(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[s] = n;
        const i = be(n) ? [] : {};
        return Ae(n, (o, u) => {
          const c = r(o, s + 1);
          !Re(c) && (i[u] = c);
        }), t[s] = void 0, i;
      }
    }
    return n;
  };
  return r(e, 0);
}, bi = Q("AsyncFunction"), gi = (e) => e && (Je(e) || X(e)) && X(e.then) && X(e.catch), gn = ((e, t) => e ? setImmediate : t ? ((r, n) => (le.addEventListener("message", ({ source: s, data: i }) => {
  s === le && i === r && n.length && n.shift()();
}, !1), (s) => {
  n.push(s), le.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  X(le.postMessage)
), Ei = typeof queueMicrotask < "u" ? queueMicrotask.bind(le) : typeof process < "u" && process.nextTick || gn, f = {
  isArray: be,
  isArrayBuffer: hn,
  isBuffer: Ls,
  isFormData: Ws,
  isArrayBufferView: Ds,
  isString: Fs,
  isNumber: fn,
  isBoolean: Us,
  isObject: Je,
  isPlainObject: Ue,
  isReadableStream: qs,
  isRequest: Xs,
  isResponse: zs,
  isHeaders: Js,
  isUndefined: Re,
  isDate: Ms,
  isFile: ks,
  isBlob: js,
  isRegExp: ui,
  isFunction: X,
  isStream: Vs,
  isURLSearchParams: $s,
  isTypedArray: ni,
  isFileList: Gs,
  forEach: Ae,
  merge: St,
  extend: Zs,
  trim: Ys,
  stripBOM: Qs,
  inherits: Ks,
  toFlatObject: ei,
  kindOf: Xe,
  kindOfTest: Q,
  endsWith: ti,
  toArray: ri,
  forEachEntry: si,
  matchAll: ii,
  isHTMLForm: oi,
  hasOwnProperty: br,
  hasOwnProp: br,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: mn,
  freezeMethods: li,
  toObjectSet: ci,
  toCamelCase: ai,
  noop: hi,
  toFiniteNumber: fi,
  findKey: dn,
  global: le,
  isContextDefined: pn,
  ALPHABET: bn,
  generateString: di,
  isSpecCompliantForm: pi,
  toJSONObject: mi,
  isAsyncFn: bi,
  isThenable: gi,
  setImmediate: gn,
  asap: Ei
};
function _(e, t, r, n, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), s && (this.response = s);
}
f.inherits(_, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: f.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const En = _.prototype, yn = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  yn[e] = { value: e };
});
Object.defineProperties(_, yn);
Object.defineProperty(En, "isAxiosError", { value: !0 });
_.from = (e, t, r, n, s, i) => {
  const o = Object.create(En);
  return f.toFlatObject(e, o, function(c) {
    return c !== Error.prototype;
  }, (u) => u !== "isAxiosError"), _.call(o, e.message, t, r, n, s), o.cause = e, o.name = e.name, i && Object.assign(o, i), o;
};
const yi = null;
function _t(e) {
  return f.isPlainObject(e) || f.isArray(e);
}
function vn(e) {
  return f.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Er(e, t, r) {
  return e ? e.concat(t).map(function(s, i) {
    return s = vn(s), !r && i ? "[" + s + "]" : s;
  }).join(r ? "." : "") : t;
}
function vi(e) {
  return f.isArray(e) && !e.some(_t);
}
const xi = f.toFlatObject(f, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Ye(e, t, r) {
  if (!f.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = f.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(y, g) {
    return !f.isUndefined(g[y]);
  });
  const n = r.metaTokens, s = r.visitor || h, i = r.dots, o = r.indexes, c = (r.Blob || typeof Blob < "u" && Blob) && f.isSpecCompliantForm(t);
  if (!f.isFunction(s))
    throw new TypeError("visitor must be a function");
  function l(E) {
    if (E === null)
      return "";
    if (f.isDate(E))
      return E.toISOString();
    if (!c && f.isBlob(E))
      throw new _("Blob is not supported. Use a Buffer instead.");
    return f.isArrayBuffer(E) || f.isTypedArray(E) ? c && typeof Blob == "function" ? new Blob([E]) : Buffer.from(E) : E;
  }
  function h(E, y, g) {
    let O = E;
    if (E && !g && typeof E == "object") {
      if (f.endsWith(y, "{}"))
        y = n ? y : y.slice(0, -2), E = JSON.stringify(E);
      else if (f.isArray(E) && vi(E) || (f.isFileList(E) || f.endsWith(y, "[]")) && (O = f.toArray(E)))
        return y = vn(y), O.forEach(function(x, L) {
          !(f.isUndefined(x) || x === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? Er([y], L, i) : o === null ? y : y + "[]",
            l(x)
          );
        }), !1;
    }
    return _t(E) ? !0 : (t.append(Er(g, y, i), l(E)), !1);
  }
  const d = [], m = Object.assign(xi, {
    defaultVisitor: h,
    convertValue: l,
    isVisitable: _t
  });
  function T(E, y) {
    if (!f.isUndefined(E)) {
      if (d.indexOf(E) !== -1)
        throw Error("Circular reference detected in " + y.join("."));
      d.push(E), f.forEach(E, function(O, w) {
        (!(f.isUndefined(O) || O === null) && s.call(
          t,
          O,
          f.isString(w) ? w.trim() : w,
          y,
          m
        )) === !0 && T(O, y ? y.concat(w) : [w]);
      }), d.pop();
    }
  }
  if (!f.isObject(e))
    throw new TypeError("data must be an object");
  return T(e), t;
}
function yr(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function Gt(e, t) {
  this._pairs = [], e && Ye(e, this, t);
}
const xn = Gt.prototype;
xn.append = function(t, r) {
  this._pairs.push([t, r]);
};
xn.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, yr);
  } : yr;
  return this._pairs.map(function(s) {
    return r(s[0]) + "=" + r(s[1]);
  }, "").join("&");
};
function Ti(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Tn(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || Ti, s = r && r.serialize;
  let i;
  if (s ? i = s(t, r) : i = f.isURLSearchParams(t) ? t.toString() : new Gt(t, r).toString(n), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class vr {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    f.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const Sn = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Si = typeof URLSearchParams < "u" ? URLSearchParams : Gt, _i = typeof FormData < "u" ? FormData : null, wi = typeof Blob < "u" ? Blob : null, Ri = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Si,
    FormData: _i,
    Blob: wi
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Vt = typeof window < "u" && typeof document < "u", Ai = ((e) => Vt && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), Oi = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Pi = Vt && window.location.href || "http://localhost", Ci = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Vt,
  hasStandardBrowserEnv: Ai,
  hasStandardBrowserWebWorkerEnv: Oi,
  origin: Pi
}, Symbol.toStringTag, { value: "Module" })), Z = {
  ...Ci,
  ...Ri
};
function Bi(e, t) {
  return Ye(e, new Z.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, s, i) {
      return Z.isNode && f.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Ni(e) {
  return f.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Hi(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const s = r.length;
  let i;
  for (n = 0; n < s; n++)
    i = r[n], t[i] = e[i];
  return t;
}
function _n(e) {
  function t(r, n, s, i) {
    let o = r[i++];
    if (o === "__proto__")
      return !0;
    const u = Number.isFinite(+o), c = i >= r.length;
    return o = !o && f.isArray(s) ? s.length : o, c ? (f.hasOwnProp(s, o) ? s[o] = [s[o], n] : s[o] = n, !u) : ((!s[o] || !f.isObject(s[o])) && (s[o] = []), t(r, n, s[o], i) && f.isArray(s[o]) && (s[o] = Hi(s[o])), !u);
  }
  if (f.isFormData(e) && f.isFunction(e.entries)) {
    const r = {};
    return f.forEachEntry(e, (n, s) => {
      t(Ni(n), s, r, 0);
    }), r;
  }
  return null;
}
function Ii(e, t, r) {
  if (f.isString(e))
    try {
      return (t || JSON.parse)(e), f.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (0, JSON.stringify)(e);
}
const Oe = {
  transitional: Sn,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", s = n.indexOf("application/json") > -1, i = f.isObject(t);
    if (i && f.isHTMLForm(t) && (t = new FormData(t)), f.isFormData(t))
      return s ? JSON.stringify(_n(t)) : t;
    if (f.isArrayBuffer(t) || f.isBuffer(t) || f.isStream(t) || f.isFile(t) || f.isBlob(t) || f.isReadableStream(t))
      return t;
    if (f.isArrayBufferView(t))
      return t.buffer;
    if (f.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let u;
    if (i) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return Bi(t, this.formSerializer).toString();
      if ((u = f.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return Ye(
          u ? { "files[]": t } : t,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return i || s ? (r.setContentType("application/json", !1), Ii(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || Oe.transitional, n = r && r.forcedJSONParsing, s = this.responseType === "json";
    if (f.isResponse(t) || f.isReadableStream(t))
      return t;
    if (t && f.isString(t) && (n && !this.responseType || s)) {
      const o = !(r && r.silentJSONParsing) && s;
      try {
        return JSON.parse(t);
      } catch (u) {
        if (o)
          throw u.name === "SyntaxError" ? _.from(u, _.ERR_BAD_RESPONSE, this, null, this.response) : u;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Z.classes.FormData,
    Blob: Z.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
f.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Oe.headers[e] = {};
});
const Li = f.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Di = (e) => {
  const t = {};
  let r, n, s;
  return e && e.split(`
`).forEach(function(o) {
    s = o.indexOf(":"), r = o.substring(0, s).trim().toLowerCase(), n = o.substring(s + 1).trim(), !(!r || t[r] && Li[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, xr = Symbol("internals");
function Te(e) {
  return e && String(e).trim().toLowerCase();
}
function Me(e) {
  return e === !1 || e == null ? e : f.isArray(e) ? e.map(Me) : String(e);
}
function Fi(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const Ui = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function ct(e, t, r, n, s) {
  if (f.isFunction(n))
    return n.call(this, t, r);
  if (s && (t = r), !!f.isString(t)) {
    if (f.isString(n))
      return t.indexOf(n) !== -1;
    if (f.isRegExp(n))
      return n.test(t);
  }
}
function Mi(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function ki(e, t) {
  const r = f.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(s, i, o) {
        return this[n].call(this, t, s, i, o);
      },
      configurable: !0
    });
  });
}
let q = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const s = this;
    function i(u, c, l) {
      const h = Te(c);
      if (!h)
        throw new Error("header name must be a non-empty string");
      const d = f.findKey(s, h);
      (!d || s[d] === void 0 || l === !0 || l === void 0 && s[d] !== !1) && (s[d || c] = Me(u));
    }
    const o = (u, c) => f.forEach(u, (l, h) => i(l, h, c));
    if (f.isPlainObject(t) || t instanceof this.constructor)
      o(t, r);
    else if (f.isString(t) && (t = t.trim()) && !Ui(t))
      o(Di(t), r);
    else if (f.isHeaders(t))
      for (const [u, c] of t.entries())
        i(c, u, n);
    else
      t != null && i(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = Te(t), t) {
      const n = f.findKey(this, t);
      if (n) {
        const s = this[n];
        if (!r)
          return s;
        if (r === !0)
          return Fi(s);
        if (f.isFunction(r))
          return r.call(this, s, n);
        if (f.isRegExp(r))
          return r.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = Te(t), t) {
      const n = f.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || ct(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let s = !1;
    function i(o) {
      if (o = Te(o), o) {
        const u = f.findKey(n, o);
        u && (!r || ct(n, n[u], u, r)) && (delete n[u], s = !0);
      }
    }
    return f.isArray(t) ? t.forEach(i) : i(t), s;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, s = !1;
    for (; n--; ) {
      const i = r[n];
      (!t || ct(this, this[i], i, t, !0)) && (delete this[i], s = !0);
    }
    return s;
  }
  normalize(t) {
    const r = this, n = {};
    return f.forEach(this, (s, i) => {
      const o = f.findKey(n, i);
      if (o) {
        r[o] = Me(s), delete r[i];
        return;
      }
      const u = t ? Mi(i) : String(i).trim();
      u !== i && delete r[i], r[u] = Me(s), n[u] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return f.forEach(this, (n, s) => {
      n != null && n !== !1 && (r[s] = t && f.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((s) => n.set(s)), n;
  }
  static accessor(t) {
    const n = (this[xr] = this[xr] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function i(o) {
      const u = Te(o);
      n[u] || (ki(s, o), n[u] = !0);
    }
    return f.isArray(t) ? t.forEach(i) : i(t), this;
  }
};
q.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
f.reduceDescriptors(q.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
f.freezeMethods(q);
function ht(e, t) {
  const r = this || Oe, n = t || r, s = q.from(n.headers);
  let i = n.data;
  return f.forEach(e, function(u) {
    i = u.call(r, i, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), i;
}
function wn(e) {
  return !!(e && e.__CANCEL__);
}
function ge(e, t, r) {
  _.call(this, e ?? "canceled", _.ERR_CANCELED, t, r), this.name = "CanceledError";
}
f.inherits(ge, _, {
  __CANCEL__: !0
});
function Rn(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new _(
    "Request failed with status code " + r.status,
    [_.ERR_BAD_REQUEST, _.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function ji(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Gi(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let s = 0, i = 0, o;
  return t = t !== void 0 ? t : 1e3, function(c) {
    const l = Date.now(), h = n[i];
    o || (o = l), r[s] = c, n[s] = l;
    let d = i, m = 0;
    for (; d !== s; )
      m += r[d++], d = d % e;
    if (s = (s + 1) % e, s === i && (i = (i + 1) % e), l - o < t)
      return;
    const T = h && l - h;
    return T ? Math.round(m * 1e3 / T) : void 0;
  };
}
function Vi(e, t) {
  let r = 0, n = 1e3 / t, s, i;
  const o = (l, h = Date.now()) => {
    r = h, s = null, i && (clearTimeout(i), i = null), e.apply(null, l);
  };
  return [(...l) => {
    const h = Date.now(), d = h - r;
    d >= n ? o(l, h) : (s = l, i || (i = setTimeout(() => {
      i = null, o(s);
    }, n - d)));
  }, () => s && o(s)];
}
const We = (e, t, r = 3) => {
  let n = 0;
  const s = Gi(50, 250);
  return Vi((i) => {
    const o = i.loaded, u = i.lengthComputable ? i.total : void 0, c = o - n, l = s(c), h = o <= u;
    n = o;
    const d = {
      loaded: o,
      total: u,
      progress: u ? o / u : void 0,
      bytes: c,
      rate: l || void 0,
      estimated: l && u && h ? (u - o) / l : void 0,
      event: i,
      lengthComputable: u != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, r);
}, Tr = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, Sr = (e) => (...t) => f.asap(() => e(...t)), Wi = Z.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a");
    let n;
    function s(i) {
      let o = i;
      return t && (r.setAttribute("href", o), o = r.href), r.setAttribute("href", o), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return n = s(window.location.href), function(o) {
      const u = f.isString(o) ? s(o) : o;
      return u.protocol === n.protocol && u.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), $i = Z.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, s, i) {
      const o = [e + "=" + encodeURIComponent(t)];
      f.isNumber(r) && o.push("expires=" + new Date(r).toGMTString()), f.isString(n) && o.push("path=" + n), f.isString(s) && o.push("domain=" + s), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function qi(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Xi(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function An(e, t) {
  return e && !qi(t) ? Xi(e, t) : t;
}
const _r = (e) => e instanceof q ? { ...e } : e;
function he(e, t) {
  t = t || {};
  const r = {};
  function n(l, h, d) {
    return f.isPlainObject(l) && f.isPlainObject(h) ? f.merge.call({ caseless: d }, l, h) : f.isPlainObject(h) ? f.merge({}, h) : f.isArray(h) ? h.slice() : h;
  }
  function s(l, h, d) {
    if (f.isUndefined(h)) {
      if (!f.isUndefined(l))
        return n(void 0, l, d);
    } else
      return n(l, h, d);
  }
  function i(l, h) {
    if (!f.isUndefined(h))
      return n(void 0, h);
  }
  function o(l, h) {
    if (f.isUndefined(h)) {
      if (!f.isUndefined(l))
        return n(void 0, l);
    } else
      return n(void 0, h);
  }
  function u(l, h, d) {
    if (d in t)
      return n(l, h);
    if (d in e)
      return n(void 0, l);
  }
  const c = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: u,
    headers: (l, h) => s(_r(l), _r(h), !0)
  };
  return f.forEach(Object.keys(Object.assign({}, e, t)), function(h) {
    const d = c[h] || s, m = d(e[h], t[h], h);
    f.isUndefined(m) && d !== u || (r[h] = m);
  }), r;
}
const On = (e) => {
  const t = he({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: u } = t;
  t.headers = o = q.from(o), t.url = Tn(An(t.baseURL, t.url), e.params, e.paramsSerializer), u && o.set(
    "Authorization",
    "Basic " + btoa((u.username || "") + ":" + (u.password ? unescape(encodeURIComponent(u.password)) : ""))
  );
  let c;
  if (f.isFormData(r)) {
    if (Z.hasStandardBrowserEnv || Z.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((c = o.getContentType()) !== !1) {
      const [l, ...h] = c ? c.split(";").map((d) => d.trim()).filter(Boolean) : [];
      o.setContentType([l || "multipart/form-data", ...h].join("; "));
    }
  }
  if (Z.hasStandardBrowserEnv && (n && f.isFunction(n) && (n = n(t)), n || n !== !1 && Wi(t.url))) {
    const l = s && i && $i.read(i);
    l && o.set(s, l);
  }
  return t;
}, zi = typeof XMLHttpRequest < "u", Ji = zi && function(e) {
  return new Promise(function(r, n) {
    const s = On(e);
    let i = s.data;
    const o = q.from(s.headers).normalize();
    let { responseType: u, onUploadProgress: c, onDownloadProgress: l } = s, h, d, m, T, E;
    function y() {
      T && T(), E && E(), s.cancelToken && s.cancelToken.unsubscribe(h), s.signal && s.signal.removeEventListener("abort", h);
    }
    let g = new XMLHttpRequest();
    g.open(s.method.toUpperCase(), s.url, !0), g.timeout = s.timeout;
    function O() {
      if (!g)
        return;
      const x = q.from(
        "getAllResponseHeaders" in g && g.getAllResponseHeaders()
      ), M = {
        data: !u || u === "text" || u === "json" ? g.responseText : g.response,
        status: g.status,
        statusText: g.statusText,
        headers: x,
        config: e,
        request: g
      };
      Rn(function(k) {
        r(k), y();
      }, function(k) {
        n(k), y();
      }, M), g = null;
    }
    "onloadend" in g ? g.onloadend = O : g.onreadystatechange = function() {
      !g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.indexOf("file:") === 0) || setTimeout(O);
    }, g.onabort = function() {
      g && (n(new _("Request aborted", _.ECONNABORTED, e, g)), g = null);
    }, g.onerror = function() {
      n(new _("Network Error", _.ERR_NETWORK, e, g)), g = null;
    }, g.ontimeout = function() {
      let L = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const M = s.transitional || Sn;
      s.timeoutErrorMessage && (L = s.timeoutErrorMessage), n(new _(
        L,
        M.clarifyTimeoutError ? _.ETIMEDOUT : _.ECONNABORTED,
        e,
        g
      )), g = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in g && f.forEach(o.toJSON(), function(L, M) {
      g.setRequestHeader(M, L);
    }), f.isUndefined(s.withCredentials) || (g.withCredentials = !!s.withCredentials), u && u !== "json" && (g.responseType = s.responseType), l && ([m, E] = We(l, !0), g.addEventListener("progress", m)), c && g.upload && ([d, T] = We(c), g.upload.addEventListener("progress", d), g.upload.addEventListener("loadend", T)), (s.cancelToken || s.signal) && (h = (x) => {
      g && (n(!x || x.type ? new ge(null, e, g) : x), g.abort(), g = null);
    }, s.cancelToken && s.cancelToken.subscribe(h), s.signal && (s.signal.aborted ? h() : s.signal.addEventListener("abort", h)));
    const w = ji(s.url);
    if (w && Z.protocols.indexOf(w) === -1) {
      n(new _("Unsupported protocol " + w + ":", _.ERR_BAD_REQUEST, e));
      return;
    }
    g.send(i || null);
  });
}, Yi = (e, t) => {
  let r = new AbortController(), n;
  const s = function(c) {
    if (!n) {
      n = !0, o();
      const l = c instanceof Error ? c : this.reason;
      r.abort(l instanceof _ ? l : new ge(l instanceof Error ? l.message : l));
    }
  };
  let i = t && setTimeout(() => {
    s(new _(`timeout ${t} of ms exceeded`, _.ETIMEDOUT));
  }, t);
  const o = () => {
    e && (i && clearTimeout(i), i = null, e.forEach((c) => {
      c && (c.removeEventListener ? c.removeEventListener("abort", s) : c.unsubscribe(s));
    }), e = null);
  };
  e.forEach((c) => c && c.addEventListener && c.addEventListener("abort", s));
  const { signal: u } = r;
  return u.unsubscribe = o, [u, () => {
    i && clearTimeout(i), i = null;
  }];
}, Zi = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, s;
  for (; n < r; )
    s = n + t, yield e.slice(n, s), n = s;
}, Qi = async function* (e, t, r) {
  for await (const n of e)
    yield* Zi(ArrayBuffer.isView(n) ? n : await r(String(n)), t);
}, wr = (e, t, r, n, s) => {
  const i = Qi(e, t, s);
  let o = 0, u, c = (l) => {
    u || (u = !0, n && n(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: h, value: d } = await i.next();
        if (h) {
          c(), l.close();
          return;
        }
        let m = d.byteLength;
        if (r) {
          let T = o += m;
          r(T);
        }
        l.enqueue(new Uint8Array(d));
      } catch (h) {
        throw c(h), h;
      }
    },
    cancel(l) {
      return c(l), i.return();
    }
  }, {
    highWaterMark: 2
  });
}, Ze = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Pn = Ze && typeof ReadableStream == "function", wt = Ze && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Cn = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Ki = Pn && Cn(() => {
  let e = !1;
  const t = new Request(Z.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), Rr = 64 * 1024, Rt = Pn && Cn(() => f.isReadableStream(new Response("").body)), $e = {
  stream: Rt && ((e) => e.body)
};
Ze && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !$e[t] && ($e[t] = f.isFunction(e[t]) ? (r) => r[t]() : (r, n) => {
      throw new _(`Response type '${t}' is not supported`, _.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const eo = async (e) => {
  if (e == null)
    return 0;
  if (f.isBlob(e))
    return e.size;
  if (f.isSpecCompliantForm(e))
    return (await new Request(e).arrayBuffer()).byteLength;
  if (f.isArrayBufferView(e) || f.isArrayBuffer(e))
    return e.byteLength;
  if (f.isURLSearchParams(e) && (e = e + ""), f.isString(e))
    return (await wt(e)).byteLength;
}, to = async (e, t) => {
  const r = f.toFiniteNumber(e.getContentLength());
  return r ?? eo(t);
}, ro = Ze && (async (e) => {
  let {
    url: t,
    method: r,
    data: n,
    signal: s,
    cancelToken: i,
    timeout: o,
    onDownloadProgress: u,
    onUploadProgress: c,
    responseType: l,
    headers: h,
    withCredentials: d = "same-origin",
    fetchOptions: m
  } = On(e);
  l = l ? (l + "").toLowerCase() : "text";
  let [T, E] = s || i || o ? Yi([s, i], o) : [], y, g;
  const O = () => {
    !y && setTimeout(() => {
      T && T.unsubscribe();
    }), y = !0;
  };
  let w;
  try {
    if (c && Ki && r !== "get" && r !== "head" && (w = await to(h, n)) !== 0) {
      let j = new Request(t, {
        method: "POST",
        body: n,
        duplex: "half"
      }), k;
      if (f.isFormData(n) && (k = j.headers.get("content-type")) && h.setContentType(k), j.body) {
        const [ie, ne] = Tr(
          w,
          We(Sr(c))
        );
        n = wr(j.body, Rr, ie, ne, wt);
      }
    }
    f.isString(d) || (d = d ? "include" : "omit"), g = new Request(t, {
      ...m,
      signal: T,
      method: r.toUpperCase(),
      headers: h.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: d
    });
    let x = await fetch(g);
    const L = Rt && (l === "stream" || l === "response");
    if (Rt && (u || L)) {
      const j = {};
      ["status", "statusText", "headers"].forEach((oe) => {
        j[oe] = x[oe];
      });
      const k = f.toFiniteNumber(x.headers.get("content-length")), [ie, ne] = u && Tr(
        k,
        We(Sr(u), !0)
      ) || [];
      x = new Response(
        wr(x.body, Rr, ie, () => {
          ne && ne(), L && O();
        }, wt),
        j
      );
    }
    l = l || "text";
    let M = await $e[f.findKey($e, l) || "text"](x, e);
    return !L && O(), E && E(), await new Promise((j, k) => {
      Rn(j, k, {
        data: M,
        headers: q.from(x.headers),
        status: x.status,
        statusText: x.statusText,
        config: e,
        request: g
      });
    });
  } catch (x) {
    throw O(), x && x.name === "TypeError" && /fetch/i.test(x.message) ? Object.assign(
      new _("Network Error", _.ERR_NETWORK, e, g),
      {
        cause: x.cause || x
      }
    ) : _.from(x, x && x.code, e, g);
  }
}), At = {
  http: yi,
  xhr: Ji,
  fetch: ro
};
f.forEach(At, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Ar = (e) => `- ${e}`, no = (e) => f.isFunction(e) || e === null || e === !1, Bn = {
  getAdapter: (e) => {
    e = f.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const s = {};
    for (let i = 0; i < t; i++) {
      r = e[i];
      let o;
      if (n = r, !no(r) && (n = At[(o = String(r)).toLowerCase()], n === void 0))
        throw new _(`Unknown adapter '${o}'`);
      if (n)
        break;
      s[o || "#" + i] = n;
    }
    if (!n) {
      const i = Object.entries(s).map(
        ([u, c]) => `adapter ${u} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = t ? i.length > 1 ? `since :
` + i.map(Ar).join(`
`) : " " + Ar(i[0]) : "as no adapter specified";
      throw new _(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: At
};
function ft(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ge(null, e);
}
function Or(e) {
  return ft(e), e.headers = q.from(e.headers), e.data = ht.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Bn.getAdapter(e.adapter || Oe.adapter)(e).then(function(n) {
    return ft(e), n.data = ht.call(
      e,
      e.transformResponse,
      n
    ), n.headers = q.from(n.headers), n;
  }, function(n) {
    return wn(n) || (ft(e), n && n.response && (n.response.data = ht.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = q.from(n.response.headers))), Promise.reject(n);
  });
}
const Nn = "1.7.4", Wt = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Wt[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Pr = {};
Wt.transitional = function(t, r, n) {
  function s(i, o) {
    return "[Axios v" + Nn + "] Transitional option '" + i + "'" + o + (n ? ". " + n : "");
  }
  return (i, o, u) => {
    if (t === !1)
      throw new _(
        s(o, " has been removed" + (r ? " in " + r : "")),
        _.ERR_DEPRECATED
      );
    return r && !Pr[o] && (Pr[o] = !0, console.warn(
      s(
        o,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(i, o, u) : !0;
  };
};
function so(e, t, r) {
  if (typeof e != "object")
    throw new _("options must be an object", _.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let s = n.length;
  for (; s-- > 0; ) {
    const i = n[s], o = t[i];
    if (o) {
      const u = e[i], c = u === void 0 || o(u, i, e);
      if (c !== !0)
        throw new _("option " + i + " must be " + c, _.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new _("Unknown option " + i, _.ERR_BAD_OPTION);
  }
}
const Ot = {
  assertOptions: so,
  validators: Wt
}, se = Ot.validators;
let ce = class {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new vr(),
      response: new vr()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error) {
        let s;
        Error.captureStackTrace ? Error.captureStackTrace(s = {}) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? i && !String(n.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + i) : n.stack = i;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = he(this.defaults, r);
    const { transitional: n, paramsSerializer: s, headers: i } = r;
    n !== void 0 && Ot.assertOptions(n, {
      silentJSONParsing: se.transitional(se.boolean),
      forcedJSONParsing: se.transitional(se.boolean),
      clarifyTimeoutError: se.transitional(se.boolean)
    }, !1), s != null && (f.isFunction(s) ? r.paramsSerializer = {
      serialize: s
    } : Ot.assertOptions(s, {
      encode: se.function,
      serialize: se.function
    }, !0)), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let o = i && f.merge(
      i.common,
      i[r.method]
    );
    i && f.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (E) => {
        delete i[E];
      }
    ), r.headers = q.concat(o, i);
    const u = [];
    let c = !0;
    this.interceptors.request.forEach(function(y) {
      typeof y.runWhen == "function" && y.runWhen(r) === !1 || (c = c && y.synchronous, u.unshift(y.fulfilled, y.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(y) {
      l.push(y.fulfilled, y.rejected);
    });
    let h, d = 0, m;
    if (!c) {
      const E = [Or.bind(this), void 0];
      for (E.unshift.apply(E, u), E.push.apply(E, l), m = E.length, h = Promise.resolve(r); d < m; )
        h = h.then(E[d++], E[d++]);
      return h;
    }
    m = u.length;
    let T = r;
    for (d = 0; d < m; ) {
      const E = u[d++], y = u[d++];
      try {
        T = E(T);
      } catch (g) {
        y.call(this, g);
        break;
      }
    }
    try {
      h = Or.call(this, T);
    } catch (E) {
      return Promise.reject(E);
    }
    for (d = 0, m = l.length; d < m; )
      h = h.then(l[d++], l[d++]);
    return h;
  }
  getUri(t) {
    t = he(this.defaults, t);
    const r = An(t.baseURL, t.url);
    return Tn(r, t.params, t.paramsSerializer);
  }
};
f.forEach(["delete", "get", "head", "options"], function(t) {
  ce.prototype[t] = function(r, n) {
    return this.request(he(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
f.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(i, o, u) {
      return this.request(he(u || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  ce.prototype[t] = r(), ce.prototype[t + "Form"] = r(!0);
});
let io = class Hn {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(i) {
      r = i;
    });
    const n = this;
    this.promise.then((s) => {
      if (!n._listeners)
        return;
      let i = n._listeners.length;
      for (; i-- > 0; )
        n._listeners[i](s);
      n._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((u) => {
        n.subscribe(u), i = u;
      }).then(s);
      return o.cancel = function() {
        n.unsubscribe(i);
      }, o;
    }, t(function(i, o, u) {
      n.reason || (n.reason = new ge(i, o, u), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Hn(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
};
function oo(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function ao(e) {
  return f.isObject(e) && e.isAxiosError === !0;
}
const Pt = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Pt).forEach(([e, t]) => {
  Pt[t] = e;
});
function In(e) {
  const t = new ce(e), r = cn(ce.prototype.request, t);
  return f.extend(r, ce.prototype, t, { allOwnKeys: !0 }), f.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(s) {
    return In(he(e, s));
  }, r;
}
const F = In(Oe);
F.Axios = ce;
F.CanceledError = ge;
F.CancelToken = io;
F.isCancel = wn;
F.VERSION = Nn;
F.toFormData = Ye;
F.AxiosError = _;
F.Cancel = F.CanceledError;
F.all = function(t) {
  return Promise.all(t);
};
F.spread = oo;
F.isAxiosError = ao;
F.mergeConfig = he;
F.AxiosHeaders = q;
F.formToJSON = (e) => _n(f.isHTMLForm(e) ? new FormData(e) : e);
F.getAdapter = Bn.getAdapter;
F.HttpStatusCode = Pt;
F.default = F;
const {
  Axios: va,
  AxiosError: uo,
  CanceledError: xa,
  isCancel: Ln,
  CancelToken: Ta,
  VERSION: Sa,
  all: _a,
  Cancel: wa,
  isAxiosError: Ra,
  spread: Aa,
  toFormData: Oa,
  AxiosHeaders: Pa,
  HttpStatusCode: Ca,
  formToJSON: Ba,
  getAdapter: Na,
  mergeConfig: Ha
} = F, ke = F.create({
  withCredentials: !0,
  headers: { "X-Requested-With": "XMLHttpRequest" }
}), Ia = (e) => ke.interceptors.response.use((t) => t, lo(e)), lo = (e) => {
  let t = !1, r = [];
  const n = () => ke.post("/api/user/token/regenerate"), s = (u) => {
    r.push(u);
  }, i = () => {
    r.forEach((u) => u()), r = [];
  }, o = async (u) => {
    const c = u.config;
    if (!t) {
      t = !0;
      try {
        return await n(), t = !1, i(), await ke(c);
      } catch (l) {
        throw t = !1, r = [], l;
      }
    }
    return new Promise((l) => {
      s(() => {
        l(ke(c));
      });
    });
  };
  return async (u) => {
    if (Ln(u))
      throw u;
    if (u = u, u.code === uo.ERR_NETWORK)
      throw new Hs();
    const c = u.response;
    if (!c)
      throw u;
    switch (c.status) {
      case 400:
        throw "errors" in c.data ? new en(c.data) : new Ve(c.data);
      case 401:
        if (Ns.includes(c.data.message))
          return await o(u);
        if (c.data.location)
          throw new an(c.data.location);
        e == null || e.error("Unauthorized response", c.data);
        break;
      case 403:
        throw new Qr();
      case 404:
        throw new Tt(Tt.isNotFoundResponse(c.data) ? c.data : void 0);
      case 409:
        throw new tn(c.data);
      case 413:
        throw new on();
      case 422:
        throw new un(c.data);
      case 423:
        throw new sn();
      case 424:
        throw new rn(c.data.title);
      case 500:
      case 502:
        throw new nn();
    }
    throw u;
  };
};
var Ct = { exports: {} }, Se = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Cr;
function co() {
  if (Cr)
    return Se;
  Cr = 1;
  var e = Yr, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(u, c, l) {
    var h, d = {}, m = null, T = null;
    l !== void 0 && (m = "" + l), c.key !== void 0 && (m = "" + c.key), c.ref !== void 0 && (T = c.ref);
    for (h in c)
      n.call(c, h) && !i.hasOwnProperty(h) && (d[h] = c[h]);
    if (u && u.defaultProps)
      for (h in c = u.defaultProps, c)
        d[h] === void 0 && (d[h] = c[h]);
    return { $$typeof: t, type: u, key: m, ref: T, props: d, _owner: s.current };
  }
  return Se.Fragment = r, Se.jsx = o, Se.jsxs = o, Se;
}
var _e = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Br;
function ho() {
  return Br || (Br = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Yr, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), E = Symbol.iterator, y = "@@iterator";
    function g(a) {
      if (a === null || typeof a != "object")
        return null;
      var p = E && a[E] || a[y];
      return typeof p == "function" ? p : null;
    }
    var O = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function w(a) {
      {
        for (var p = arguments.length, b = new Array(p > 1 ? p - 1 : 0), S = 1; S < p; S++)
          b[S - 1] = arguments[S];
        x("error", a, b);
      }
    }
    function x(a, p, b) {
      {
        var S = O.ReactDebugCurrentFrame, B = S.getStackAddendum();
        B !== "" && (p += "%s", b = b.concat([B]));
        var N = b.map(function(P) {
          return String(P);
        });
        N.unshift("Warning: " + p), Function.prototype.apply.call(console[a], console, N);
      }
    }
    var L = !1, M = !1, j = !1, k = !1, ie = !1, ne;
    ne = Symbol.for("react.module.reference");
    function oe(a) {
      return !!(typeof a == "string" || typeof a == "function" || a === n || a === i || ie || a === s || a === l || a === h || k || a === T || L || M || j || typeof a == "object" && a !== null && (a.$$typeof === m || a.$$typeof === d || a.$$typeof === o || a.$$typeof === u || a.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      a.$$typeof === ne || a.getModuleId !== void 0));
    }
    function Pe(a, p, b) {
      var S = a.displayName;
      if (S)
        return S;
      var B = p.displayName || p.name || "";
      return B !== "" ? b + "(" + B + ")" : b;
    }
    function Ee(a) {
      return a.displayName || "Context";
    }
    function v(a) {
      if (a == null)
        return null;
      if (typeof a.tag == "number" && w("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
        return a.displayName || a.name || null;
      if (typeof a == "string")
        return a;
      switch (a) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case l:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case u:
            var p = a;
            return Ee(p) + ".Consumer";
          case o:
            var b = a;
            return Ee(b._context) + ".Provider";
          case c:
            return Pe(a, a.render, "ForwardRef");
          case d:
            var S = a.displayName || null;
            return S !== null ? S : v(a.type) || "Memo";
          case m: {
            var B = a, N = B._payload, P = B._init;
            try {
              return v(P(N));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ae = 0, Xt, zt, Jt, Yt, Zt, Qt, Kt;
    function er() {
    }
    er.__reactDisabledLog = !0;
    function rs() {
      {
        if (ae === 0) {
          Xt = console.log, zt = console.info, Jt = console.warn, Yt = console.error, Zt = console.group, Qt = console.groupCollapsed, Kt = console.groupEnd;
          var a = {
            configurable: !0,
            enumerable: !0,
            value: er,
            writable: !0
          };
          Object.defineProperties(console, {
            info: a,
            log: a,
            warn: a,
            error: a,
            group: a,
            groupCollapsed: a,
            groupEnd: a
          });
        }
        ae++;
      }
    }
    function ns() {
      {
        if (ae--, ae === 0) {
          var a = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, a, {
              value: Xt
            }),
            info: K({}, a, {
              value: zt
            }),
            warn: K({}, a, {
              value: Jt
            }),
            error: K({}, a, {
              value: Yt
            }),
            group: K({}, a, {
              value: Zt
            }),
            groupCollapsed: K({}, a, {
              value: Qt
            }),
            groupEnd: K({}, a, {
              value: Kt
            })
          });
        }
        ae < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var et = O.ReactCurrentDispatcher, tt;
    function Ce(a, p, b) {
      {
        if (tt === void 0)
          try {
            throw Error();
          } catch (B) {
            var S = B.stack.trim().match(/\n( *(at )?)/);
            tt = S && S[1] || "";
          }
        return `
` + tt + a;
      }
    }
    var rt = !1, Be;
    {
      var ss = typeof WeakMap == "function" ? WeakMap : Map;
      Be = new ss();
    }
    function tr(a, p) {
      if (!a || rt)
        return "";
      {
        var b = Be.get(a);
        if (b !== void 0)
          return b;
      }
      var S;
      rt = !0;
      var B = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var N;
      N = et.current, et.current = null, rs();
      try {
        if (p) {
          var P = function() {
            throw Error();
          };
          if (Object.defineProperty(P.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(P, []);
            } catch ($) {
              S = $;
            }
            Reflect.construct(a, [], P);
          } else {
            try {
              P.call();
            } catch ($) {
              S = $;
            }
            a.call(P.prototype);
          }
        } else {
          try {
            throw Error();
          } catch ($) {
            S = $;
          }
          a();
        }
      } catch ($) {
        if ($ && S && typeof $.stack == "string") {
          for (var R = $.stack.split(`
`), V = S.stack.split(`
`), D = R.length - 1, U = V.length - 1; D >= 1 && U >= 0 && R[D] !== V[U]; )
            U--;
          for (; D >= 1 && U >= 0; D--, U--)
            if (R[D] !== V[U]) {
              if (D !== 1 || U !== 1)
                do
                  if (D--, U--, U < 0 || R[D] !== V[U]) {
                    var z = `
` + R[D].replace(" at new ", " at ");
                    return a.displayName && z.includes("<anonymous>") && (z = z.replace("<anonymous>", a.displayName)), typeof a == "function" && Be.set(a, z), z;
                  }
                while (D >= 1 && U >= 0);
              break;
            }
        }
      } finally {
        rt = !1, et.current = N, ns(), Error.prepareStackTrace = B;
      }
      var de = a ? a.displayName || a.name : "", ue = de ? Ce(de) : "";
      return typeof a == "function" && Be.set(a, ue), ue;
    }
    function is(a, p, b) {
      return tr(a, !1);
    }
    function os(a) {
      var p = a.prototype;
      return !!(p && p.isReactComponent);
    }
    function Ne(a, p, b) {
      if (a == null)
        return "";
      if (typeof a == "function")
        return tr(a, os(a));
      if (typeof a == "string")
        return Ce(a);
      switch (a) {
        case l:
          return Ce("Suspense");
        case h:
          return Ce("SuspenseList");
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case c:
            return is(a.render);
          case d:
            return Ne(a.type, p, b);
          case m: {
            var S = a, B = S._payload, N = S._init;
            try {
              return Ne(N(B), p, b);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, rr = {}, nr = O.ReactDebugCurrentFrame;
    function He(a) {
      if (a) {
        var p = a._owner, b = Ne(a.type, a._source, p ? p.type : null);
        nr.setExtraStackFrame(b);
      } else
        nr.setExtraStackFrame(null);
    }
    function as(a, p, b, S, B) {
      {
        var N = Function.call.bind(ye);
        for (var P in a)
          if (N(a, P)) {
            var R = void 0;
            try {
              if (typeof a[P] != "function") {
                var V = Error((S || "React class") + ": " + b + " type `" + P + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[P] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw V.name = "Invariant Violation", V;
              }
              R = a[P](p, P, S, b, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (D) {
              R = D;
            }
            R && !(R instanceof Error) && (He(B), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", S || "React class", b, P, typeof R), He(null)), R instanceof Error && !(R.message in rr) && (rr[R.message] = !0, He(B), w("Failed %s type: %s", b, R.message), He(null));
          }
      }
    }
    var us = Array.isArray;
    function nt(a) {
      return us(a);
    }
    function ls(a) {
      {
        var p = typeof Symbol == "function" && Symbol.toStringTag, b = p && a[Symbol.toStringTag] || a.constructor.name || "Object";
        return b;
      }
    }
    function cs(a) {
      try {
        return sr(a), !1;
      } catch {
        return !0;
      }
    }
    function sr(a) {
      return "" + a;
    }
    function ir(a) {
      if (cs(a))
        return w("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ls(a)), sr(a);
    }
    var ve = O.ReactCurrentOwner, hs = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, or, ar, st;
    st = {};
    function fs(a) {
      if (ye.call(a, "ref")) {
        var p = Object.getOwnPropertyDescriptor(a, "ref").get;
        if (p && p.isReactWarning)
          return !1;
      }
      return a.ref !== void 0;
    }
    function ds(a) {
      if (ye.call(a, "key")) {
        var p = Object.getOwnPropertyDescriptor(a, "key").get;
        if (p && p.isReactWarning)
          return !1;
      }
      return a.key !== void 0;
    }
    function ps(a, p) {
      if (typeof a.ref == "string" && ve.current && p && ve.current.stateNode !== p) {
        var b = v(ve.current.type);
        st[b] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', v(ve.current.type), a.ref), st[b] = !0);
      }
    }
    function ms(a, p) {
      {
        var b = function() {
          or || (or = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", p));
        };
        b.isReactWarning = !0, Object.defineProperty(a, "key", {
          get: b,
          configurable: !0
        });
      }
    }
    function bs(a, p) {
      {
        var b = function() {
          ar || (ar = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", p));
        };
        b.isReactWarning = !0, Object.defineProperty(a, "ref", {
          get: b,
          configurable: !0
        });
      }
    }
    var gs = function(a, p, b, S, B, N, P) {
      var R = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: a,
        key: p,
        ref: b,
        props: P,
        // Record the component responsible for creating this element.
        _owner: N
      };
      return R._store = {}, Object.defineProperty(R._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(R, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: S
      }), Object.defineProperty(R, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: B
      }), Object.freeze && (Object.freeze(R.props), Object.freeze(R)), R;
    };
    function Es(a, p, b, S, B) {
      {
        var N, P = {}, R = null, V = null;
        b !== void 0 && (ir(b), R = "" + b), ds(p) && (ir(p.key), R = "" + p.key), fs(p) && (V = p.ref, ps(p, B));
        for (N in p)
          ye.call(p, N) && !hs.hasOwnProperty(N) && (P[N] = p[N]);
        if (a && a.defaultProps) {
          var D = a.defaultProps;
          for (N in D)
            P[N] === void 0 && (P[N] = D[N]);
        }
        if (R || V) {
          var U = typeof a == "function" ? a.displayName || a.name || "Unknown" : a;
          R && ms(P, U), V && bs(P, U);
        }
        return gs(a, R, V, B, S, ve.current, P);
      }
    }
    var it = O.ReactCurrentOwner, ur = O.ReactDebugCurrentFrame;
    function fe(a) {
      if (a) {
        var p = a._owner, b = Ne(a.type, a._source, p ? p.type : null);
        ur.setExtraStackFrame(b);
      } else
        ur.setExtraStackFrame(null);
    }
    var ot;
    ot = !1;
    function at(a) {
      return typeof a == "object" && a !== null && a.$$typeof === t;
    }
    function lr() {
      {
        if (it.current) {
          var a = v(it.current.type);
          if (a)
            return `

Check the render method of \`` + a + "`.";
        }
        return "";
      }
    }
    function ys(a) {
      return "";
    }
    var cr = {};
    function vs(a) {
      {
        var p = lr();
        if (!p) {
          var b = typeof a == "string" ? a : a.displayName || a.name;
          b && (p = `

Check the top-level render call using <` + b + ">.");
        }
        return p;
      }
    }
    function hr(a, p) {
      {
        if (!a._store || a._store.validated || a.key != null)
          return;
        a._store.validated = !0;
        var b = vs(p);
        if (cr[b])
          return;
        cr[b] = !0;
        var S = "";
        a && a._owner && a._owner !== it.current && (S = " It was passed a child from " + v(a._owner.type) + "."), fe(a), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', b, S), fe(null);
      }
    }
    function fr(a, p) {
      {
        if (typeof a != "object")
          return;
        if (nt(a))
          for (var b = 0; b < a.length; b++) {
            var S = a[b];
            at(S) && hr(S, p);
          }
        else if (at(a))
          a._store && (a._store.validated = !0);
        else if (a) {
          var B = g(a);
          if (typeof B == "function" && B !== a.entries)
            for (var N = B.call(a), P; !(P = N.next()).done; )
              at(P.value) && hr(P.value, p);
        }
      }
    }
    function xs(a) {
      {
        var p = a.type;
        if (p == null || typeof p == "string")
          return;
        var b;
        if (typeof p == "function")
          b = p.propTypes;
        else if (typeof p == "object" && (p.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        p.$$typeof === d))
          b = p.propTypes;
        else
          return;
        if (b) {
          var S = v(p);
          as(b, a.props, "prop", S, a);
        } else if (p.PropTypes !== void 0 && !ot) {
          ot = !0;
          var B = v(p);
          w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", B || "Unknown");
        }
        typeof p.getDefaultProps == "function" && !p.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ts(a) {
      {
        for (var p = Object.keys(a.props), b = 0; b < p.length; b++) {
          var S = p[b];
          if (S !== "children" && S !== "key") {
            fe(a), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", S), fe(null);
            break;
          }
        }
        a.ref !== null && (fe(a), w("Invalid attribute `ref` supplied to `React.Fragment`."), fe(null));
      }
    }
    var dr = {};
    function pr(a, p, b, S, B, N) {
      {
        var P = oe(a);
        if (!P) {
          var R = "";
          (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (R += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var V = ys();
          V ? R += V : R += lr();
          var D;
          a === null ? D = "null" : nt(a) ? D = "array" : a !== void 0 && a.$$typeof === t ? (D = "<" + (v(a.type) || "Unknown") + " />", R = " Did you accidentally export a JSX literal instead of a component?") : D = typeof a, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", D, R);
        }
        var U = Es(a, p, b, B, N);
        if (U == null)
          return U;
        if (P) {
          var z = p.children;
          if (z !== void 0)
            if (S)
              if (nt(z)) {
                for (var de = 0; de < z.length; de++)
                  fr(z[de], a);
                Object.freeze && Object.freeze(z);
              } else
                w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              fr(z, a);
        }
        if (ye.call(p, "key")) {
          var ue = v(a), $ = Object.keys(p).filter(function(Os) {
            return Os !== "key";
          }), ut = $.length > 0 ? "{key: someKey, " + $.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!dr[ue + ut]) {
            var As = $.length > 0 ? "{" + $.join(": ..., ") + ": ...}" : "{}";
            w(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ut, ue, As, ue), dr[ue + ut] = !0;
          }
        }
        return a === n ? Ts(U) : xs(U), U;
      }
    }
    function Ss(a, p, b) {
      return pr(a, p, b, !0);
    }
    function _s(a, p, b) {
      return pr(a, p, b, !1);
    }
    var ws = _s, Rs = Ss;
    _e.Fragment = n, _e.jsx = ws, _e.jsxs = Rs;
  }()), _e;
}
process.env.NODE_ENV === "production" ? Ct.exports = co() : Ct.exports = ho();
var Nr = Ct.exports;
const La = ({
  httpClient: e,
  useRouter: t,
  useLocoTranslation: r
}) => function({
  method: s,
  showFieldsErrorToast: i,
  stopErrorPropagation: o,
  badRequestHandler: u,
  unauthorizedResponseHandler: c,
  unprocessableContentHandler: l,
  internalErrorHandler: h,
  afterFetch: d,
  accessDeniedHandler: m,
  onErrorBeforeErrorHandlers: T,
  onNotFound: E,
  mock: y
}) {
  const g = t(), { t: O } = r(), [w, x] = mr(0), [L, M] = mr(!1);
  return Zr(() => M(!!w), [w]), { fetcher: xt(
    async (...k) => {
      var oe, Pe, Ee;
      x((v) => v + 1);
      const ie = typeof process < "u" && ((oe = process.env) == null ? void 0 : oe.NODE_ENV) === "development" || typeof process < "u" && ((Pe = process.env) == null ? void 0 : Pe.NEXT_PUBLIC_APP_ENV) === "development" || typeof process < "u" && ((Ee = process.env) == null ? void 0 : Ee.APP_ENV) === "development";
      return (y && ie ? new Promise((v, K) => {
        const ae = y.delay ?? 3e3;
        setTimeout(() => {
          y.error ? K(y.error) : v(y.data);
        }, ae);
      }) : e[s](
        k[0],
        k[1],
        k[2]
      ).then(async (v) => v && (d ? await d(v.data, v) : v.data))).catch(T).catch(async (v) => {
        if (typeof window < "u" && v instanceof Tt)
          E ? E(v) : process.env.NODE_ENV !== "development" && g.replace("/not-found");
        else if (typeof window < "u" && v instanceof Qr)
          m ? m(v) : g.push("/403");
        else if (typeof window < "u" && v instanceof an)
          c ? c(v) : window.location.assign(v.location);
        else if (typeof window < "u" && v instanceof nn)
          h ? h(v) : te.error(O("core.error.internal_error_message"));
        else if (v instanceof en)
          i && v.errors && ln(v.errors.fields) && te.error(O("global.errors.fields_toast_message")), u ? u(v) : v.message && te.error(/* @__PURE__ */ Nr.jsx("p", { dangerouslySetInnerHTML: { __html: v.message } }));
        else if (v instanceof tn)
          te.error(O("core.error.conflict_error_message"));
        else if (v instanceof un)
          l ? l(v) : te.error(v.message || O("core.error.conflict_error_message"));
        else if (v instanceof sn)
          te.error(v.message);
        else if (v instanceof on)
          te.error(O("core.error.payload_to_large_error_message"));
        else if (v instanceof rn)
          te.error(/* @__PURE__ */ Nr.jsx("p", { dangerouslySetInnerHTML: { __html: v.message } }));
        else {
          if (v instanceof Bs)
            throw v;
          !(Ln(v) || v.code === "ECONNABORTED") && te.error(O("global.error"));
        }
        if (!o)
          throw v;
      }).finally(() => x((v) => v - 1));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      s,
      d,
      g,
      c,
      i,
      u,
      l,
      m,
      T
    ]
  ), isFetching: L };
};
var fo = /* @__PURE__ */ ((e) => (e.get = "get", e.delete = "delete", e.head = "head", e.options = "options", e.post = "post", e.put = "put", e.patch = "patch", e.postForm = "postForm", e))(fo || {});
const Da = [
  "get",
  "delete",
  "head",
  "options"
  /* options */
];
var Bt = function(e, t) {
  return Bt = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var s in n)
      Object.prototype.hasOwnProperty.call(n, s) && (r[s] = n[s]);
  }, Bt(e, t);
};
function Qe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Bt(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var ee = function() {
  return ee = Object.assign || function(t) {
    for (var r, n = 1, s = arguments.length; n < s; n++) {
      r = arguments[n];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, ee.apply(this, arguments);
};
function po(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, n = Object.getOwnPropertySymbols(e); s < n.length; s++)
      t.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[s]) && (r[n[s]] = e[n[s]]);
  return r;
}
function dt(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, s = t.length, i; n < s; n++)
      (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var qe = function() {
  return qe = Object.assign || function(t) {
    for (var r, n = 1, s = arguments.length; n < s; n++) {
      r = arguments[n];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, qe.apply(this, arguments);
};
var A;
(function(e) {
  e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
})(A || (A = {}));
var H;
(function(e) {
  e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
})(H || (H = {}));
var pe;
(function(e) {
  e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
})(pe || (pe = {}));
function Hr(e) {
  return e.type === H.literal;
}
function mo(e) {
  return e.type === H.argument;
}
function Dn(e) {
  return e.type === H.number;
}
function Fn(e) {
  return e.type === H.date;
}
function Un(e) {
  return e.type === H.time;
}
function Mn(e) {
  return e.type === H.select;
}
function kn(e) {
  return e.type === H.plural;
}
function bo(e) {
  return e.type === H.pound;
}
function jn(e) {
  return e.type === H.tag;
}
function Gn(e) {
  return !!(e && typeof e == "object" && e.type === pe.number);
}
function Nt(e) {
  return !!(e && typeof e == "object" && e.type === pe.dateTime);
}
var Vn = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, go = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function Eo(e) {
  var t = {};
  return e.replace(go, function(r) {
    var n = r.length;
    switch (r[0]) {
      case "G":
        t.era = n === 4 ? "long" : n === 5 ? "narrow" : "short";
        break;
      case "y":
        t.year = n === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      case "M":
      case "L":
        t.month = ["numeric", "2-digit", "short", "long", "narrow"][n - 1];
        break;
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        t.day = ["numeric", "2-digit"][n - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      case "E":
        t.weekday = n === 4 ? "long" : n === 5 ? "narrow" : "short";
        break;
      case "e":
        if (n < 4)
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][n - 4];
        break;
      case "c":
        if (n < 4)
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][n - 4];
        break;
      case "a":
        t.hour12 = !0;
        break;
      case "b":
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      case "h":
        t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "H":
        t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "K":
        t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "k":
        t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      case "m":
        t.minute = ["numeric", "2-digit"][n - 1];
        break;
      case "s":
        t.second = ["numeric", "2-digit"][n - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      case "z":
        t.timeZoneName = n < 4 ? "short" : "long";
        break;
      case "Z":
      case "O":
      case "v":
      case "V":
      case "X":
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  }), t;
}
var I = function() {
  return I = Object.assign || function(t) {
    for (var r, n = 1, s = arguments.length; n < s; n++) {
      r = arguments[n];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, I.apply(this, arguments);
};
var yo = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function vo(e) {
  if (e.length === 0)
    throw new Error("Number skeleton cannot be empty");
  for (var t = e.split(yo).filter(function(m) {
    return m.length > 0;
  }), r = [], n = 0, s = t; n < s.length; n++) {
    var i = s[n], o = i.split("/");
    if (o.length === 0)
      throw new Error("Invalid number skeleton");
    for (var u = o[0], c = o.slice(1), l = 0, h = c; l < h.length; l++) {
      var d = h[l];
      if (d.length === 0)
        throw new Error("Invalid number skeleton");
    }
    r.push({ stem: u, options: c });
  }
  return r;
}
function xo(e) {
  return e.replace(/^(.*?)-/, "");
}
var Ir = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, Wn = /^(@+)?(\+|#+)?[rs]?$/g, To = /(\*)(0+)|(#+)(0+)|(0+)/g, $n = /^(0+)$/;
function Lr(e) {
  var t = {};
  return e[e.length - 1] === "r" ? t.roundingPriority = "morePrecision" : e[e.length - 1] === "s" && (t.roundingPriority = "lessPrecision"), e.replace(Wn, function(r, n, s) {
    return typeof s != "string" ? (t.minimumSignificantDigits = n.length, t.maximumSignificantDigits = n.length) : s === "+" ? t.minimumSignificantDigits = n.length : n[0] === "#" ? t.maximumSignificantDigits = n.length : (t.minimumSignificantDigits = n.length, t.maximumSignificantDigits = n.length + (typeof s == "string" ? s.length : 0)), "";
  }), t;
}
function qn(e) {
  switch (e) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function So(e) {
  var t;
  if (e[0] === "E" && e[1] === "E" ? (t = {
    notation: "engineering"
  }, e = e.slice(2)) : e[0] === "E" && (t = {
    notation: "scientific"
  }, e = e.slice(1)), t) {
    var r = e.slice(0, 2);
    if (r === "+!" ? (t.signDisplay = "always", e = e.slice(2)) : r === "+?" && (t.signDisplay = "exceptZero", e = e.slice(2)), !$n.test(e))
      throw new Error("Malformed concise eng/scientific notation");
    t.minimumIntegerDigits = e.length;
  }
  return t;
}
function Dr(e) {
  var t = {}, r = qn(e);
  return r || t;
}
function _o(e) {
  for (var t = {}, r = 0, n = e; r < n.length; r++) {
    var s = n[r];
    switch (s.stem) {
      case "percent":
      case "%":
        t.style = "percent";
        continue;
      case "%x100":
        t.style = "percent", t.scale = 100;
        continue;
      case "currency":
        t.style = "currency", t.currency = s.options[0];
        continue;
      case "group-off":
      case ",_":
        t.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        t.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        t.style = "unit", t.unit = xo(s.options[0]);
        continue;
      case "compact-short":
      case "K":
        t.notation = "compact", t.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        t.notation = "compact", t.compactDisplay = "long";
        continue;
      case "scientific":
        t = I(I(I({}, t), { notation: "scientific" }), s.options.reduce(function(c, l) {
          return I(I({}, c), Dr(l));
        }, {}));
        continue;
      case "engineering":
        t = I(I(I({}, t), { notation: "engineering" }), s.options.reduce(function(c, l) {
          return I(I({}, c), Dr(l));
        }, {}));
        continue;
      case "notation-simple":
        t.notation = "standard";
        continue;
      case "unit-width-narrow":
        t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        t.currencyDisplay = "code", t.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        t.currencyDisplay = "name", t.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        t.currencyDisplay = "symbol";
        continue;
      case "scale":
        t.scale = parseFloat(s.options[0]);
        continue;
      case "rounding-mode-floor":
        t.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        t.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        t.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        t.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        t.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        t.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        t.roundingMode = "halfExpand";
        continue;
      case "integer-width":
        if (s.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        s.options[0].replace(To, function(c, l, h, d, m, T) {
          if (l)
            t.minimumIntegerDigits = h.length;
          else {
            if (d && m)
              throw new Error("We currently do not support maximum integer digits");
            if (T)
              throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if ($n.test(s.stem)) {
      t.minimumIntegerDigits = s.stem.length;
      continue;
    }
    if (Ir.test(s.stem)) {
      if (s.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      s.stem.replace(Ir, function(c, l, h, d, m, T) {
        return h === "*" ? t.minimumFractionDigits = l.length : d && d[0] === "#" ? t.maximumFractionDigits = d.length : m && T ? (t.minimumFractionDigits = m.length, t.maximumFractionDigits = m.length + T.length) : (t.minimumFractionDigits = l.length, t.maximumFractionDigits = l.length), "";
      });
      var i = s.options[0];
      i === "w" ? t = I(I({}, t), { trailingZeroDisplay: "stripIfInteger" }) : i && (t = I(I({}, t), Lr(i)));
      continue;
    }
    if (Wn.test(s.stem)) {
      t = I(I({}, t), Lr(s.stem));
      continue;
    }
    var o = qn(s.stem);
    o && (t = I(I({}, t), o));
    var u = So(s.stem);
    u && (t = I(I({}, t), u));
  }
  return t;
}
var Ie = {
  "001": [
    "H",
    "h"
  ],
  AC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AD: [
    "H",
    "hB"
  ],
  AE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  AF: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  AG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AL: [
    "h",
    "H",
    "hB"
  ],
  AM: [
    "H",
    "hB"
  ],
  AO: [
    "H",
    "hB"
  ],
  AR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  AS: [
    "h",
    "H"
  ],
  AT: [
    "H",
    "hB"
  ],
  AU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AW: [
    "H",
    "hB"
  ],
  AX: [
    "H"
  ],
  AZ: [
    "H",
    "hB",
    "h"
  ],
  BA: [
    "H",
    "hB",
    "h"
  ],
  BB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BD: [
    "h",
    "hB",
    "H"
  ],
  BE: [
    "H",
    "hB"
  ],
  BF: [
    "H",
    "hB"
  ],
  BG: [
    "H",
    "hB",
    "h"
  ],
  BH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  BI: [
    "H",
    "h"
  ],
  BJ: [
    "H",
    "hB"
  ],
  BL: [
    "H",
    "hB"
  ],
  BM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BN: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  BO: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  BQ: [
    "H"
  ],
  BR: [
    "H",
    "hB"
  ],
  BS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BT: [
    "h",
    "H"
  ],
  BW: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  BY: [
    "H",
    "h"
  ],
  BZ: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CA: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  CC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CD: [
    "hB",
    "H"
  ],
  CF: [
    "H",
    "h",
    "hB"
  ],
  CG: [
    "H",
    "hB"
  ],
  CH: [
    "H",
    "hB",
    "h"
  ],
  CI: [
    "H",
    "hB"
  ],
  CK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CL: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CM: [
    "H",
    "h",
    "hB"
  ],
  CN: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  CO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CP: [
    "H"
  ],
  CR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CU: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CV: [
    "H",
    "hB"
  ],
  CW: [
    "H",
    "hB"
  ],
  CX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CY: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  CZ: [
    "H"
  ],
  DE: [
    "H",
    "hB"
  ],
  DG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  DJ: [
    "h",
    "H"
  ],
  DK: [
    "H"
  ],
  DM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  DO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  DZ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  EC: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  EE: [
    "H",
    "hB"
  ],
  EG: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  ER: [
    "h",
    "H"
  ],
  ES: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  ET: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  FI: [
    "H"
  ],
  FJ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  FM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FO: [
    "H",
    "h"
  ],
  FR: [
    "H",
    "hB"
  ],
  GA: [
    "H",
    "hB"
  ],
  GB: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GD: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GE: [
    "H",
    "hB",
    "h"
  ],
  GF: [
    "H",
    "hB"
  ],
  GG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GH: [
    "h",
    "H"
  ],
  GI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GL: [
    "H",
    "h"
  ],
  GM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GN: [
    "H",
    "hB"
  ],
  GP: [
    "H",
    "hB"
  ],
  GQ: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  GR: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  GT: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  GU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GW: [
    "H",
    "hB"
  ],
  GY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  HK: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  HN: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  HR: [
    "H",
    "hB"
  ],
  HU: [
    "H",
    "h"
  ],
  IC: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  ID: [
    "H"
  ],
  IE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IL: [
    "H",
    "hB"
  ],
  IM: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IN: [
    "h",
    "H"
  ],
  IO: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IQ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  IR: [
    "hB",
    "H"
  ],
  IS: [
    "H"
  ],
  IT: [
    "H",
    "hB"
  ],
  JE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  JM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  JO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  JP: [
    "H",
    "K",
    "h"
  ],
  KE: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  KG: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KH: [
    "hB",
    "h",
    "H",
    "hb"
  ],
  KI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KM: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KN: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KP: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KW: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  KY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KZ: [
    "H",
    "hB"
  ],
  LA: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  LB: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  LC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LI: [
    "H",
    "hB",
    "h"
  ],
  LK: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  LR: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LS: [
    "h",
    "H"
  ],
  LT: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  LU: [
    "H",
    "h",
    "hB"
  ],
  LV: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  LY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MC: [
    "H",
    "hB"
  ],
  MD: [
    "H",
    "hB"
  ],
  ME: [
    "H",
    "hB",
    "h"
  ],
  MF: [
    "H",
    "hB"
  ],
  MG: [
    "H",
    "h"
  ],
  MH: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ML: [
    "H"
  ],
  MM: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  MN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MP: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MQ: [
    "H",
    "hB"
  ],
  MR: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MS: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MT: [
    "H",
    "h"
  ],
  MU: [
    "H",
    "h"
  ],
  MV: [
    "H",
    "h"
  ],
  MW: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MX: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MY: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  MZ: [
    "H",
    "hB"
  ],
  NA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NC: [
    "H",
    "hB"
  ],
  NE: [
    "H"
  ],
  NF: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NI: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  NL: [
    "H",
    "hB"
  ],
  NO: [
    "H",
    "h"
  ],
  NP: [
    "H",
    "h",
    "hB"
  ],
  NR: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NU: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  OM: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PE: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  PF: [
    "H",
    "h",
    "hB"
  ],
  PG: [
    "h",
    "H"
  ],
  PH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PK: [
    "h",
    "hB",
    "H"
  ],
  PL: [
    "H",
    "h"
  ],
  PM: [
    "H",
    "hB"
  ],
  PN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  PR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PS: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PT: [
    "H",
    "hB"
  ],
  PW: [
    "h",
    "H"
  ],
  PY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  QA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  RE: [
    "H",
    "hB"
  ],
  RO: [
    "H",
    "hB"
  ],
  RS: [
    "H",
    "hB",
    "h"
  ],
  RU: [
    "H"
  ],
  RW: [
    "H",
    "h"
  ],
  SA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SC: [
    "H",
    "h",
    "hB"
  ],
  SD: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SE: [
    "H"
  ],
  SG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SH: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SI: [
    "H",
    "hB"
  ],
  SJ: [
    "H"
  ],
  SK: [
    "H"
  ],
  SL: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SM: [
    "H",
    "h",
    "hB"
  ],
  SN: [
    "H",
    "h",
    "hB"
  ],
  SO: [
    "h",
    "H"
  ],
  SR: [
    "H",
    "hB"
  ],
  SS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ST: [
    "H",
    "hB"
  ],
  SV: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  SX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  TC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TD: [
    "h",
    "H",
    "hB"
  ],
  TF: [
    "H",
    "h",
    "hB"
  ],
  TG: [
    "H",
    "hB"
  ],
  TH: [
    "H",
    "h"
  ],
  TJ: [
    "H",
    "h"
  ],
  TL: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  TM: [
    "H",
    "h"
  ],
  TN: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  TO: [
    "h",
    "H"
  ],
  TR: [
    "H",
    "hB"
  ],
  TT: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TW: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  TZ: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UA: [
    "H",
    "hB",
    "h"
  ],
  UG: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  US: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  UY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  UZ: [
    "H",
    "hB",
    "h"
  ],
  VA: [
    "H",
    "h",
    "hB"
  ],
  VC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  VG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VN: [
    "H",
    "h"
  ],
  VU: [
    "h",
    "H"
  ],
  WF: [
    "H",
    "hB"
  ],
  WS: [
    "h",
    "H"
  ],
  XK: [
    "H",
    "hB",
    "h"
  ],
  YE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  YT: [
    "H",
    "hB"
  ],
  ZA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ZM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ZW: [
    "H",
    "h"
  ],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "es-BO": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-EC": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-PE": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ]
};
function wo(e, t) {
  for (var r = "", n = 0; n < e.length; n++) {
    var s = e.charAt(n);
    if (s === "j") {
      for (var i = 0; n + 1 < e.length && e.charAt(n + 1) === s; )
        i++, n++;
      var o = 1 + (i & 1), u = i < 2 ? 1 : 3 + (i >> 1), c = "a", l = Ro(t);
      for ((l == "H" || l == "k") && (u = 0); u-- > 0; )
        r += c;
      for (; o-- > 0; )
        r = l + r;
    } else
      s === "J" ? r += "H" : r += s;
  }
  return r;
}
function Ro(e) {
  var t = e.hourCycle;
  if (t === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  e.hourCycles && // @ts-ignore
  e.hourCycles.length && (t = e.hourCycles[0]), t)
    switch (t) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  var r = e.language, n;
  r !== "root" && (n = e.maximize().region);
  var s = Ie[n || ""] || Ie[r || ""] || Ie["".concat(r, "-001")] || Ie["001"];
  return s[0];
}
var pt, Ao = new RegExp("^".concat(Vn.source, "*")), Oo = new RegExp("".concat(Vn.source, "*$"));
function C(e, t) {
  return { start: e, end: t };
}
var Po = !!String.prototype.startsWith && "_a".startsWith("a", 1), Co = !!String.fromCodePoint, Bo = !!Object.fromEntries, No = !!String.prototype.codePointAt, Ho = !!String.prototype.trimStart, Io = !!String.prototype.trimEnd, Lo = !!Number.isSafeInteger, Do = Lo ? Number.isSafeInteger : function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
}, Ht = !0;
try {
  var Fo = zn("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  Ht = ((pt = Fo.exec("a")) === null || pt === void 0 ? void 0 : pt[0]) === "a";
} catch {
  Ht = !1;
}
var Fr = Po ? (
  // Native
  function(t, r, n) {
    return t.startsWith(r, n);
  }
) : (
  // For IE11
  function(t, r, n) {
    return t.slice(n, n + r.length) === r;
  }
), It = Co ? String.fromCodePoint : (
  // IE11
  function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    for (var n = "", s = t.length, i = 0, o; s > i; ) {
      if (o = t[i++], o > 1114111)
        throw RangeError(o + " is not a valid code point");
      n += o < 65536 ? String.fromCharCode(o) : String.fromCharCode(((o -= 65536) >> 10) + 55296, o % 1024 + 56320);
    }
    return n;
  }
), Ur = (
  // native
  Bo ? Object.fromEntries : (
    // Ponyfill
    function(t) {
      for (var r = {}, n = 0, s = t; n < s.length; n++) {
        var i = s[n], o = i[0], u = i[1];
        r[o] = u;
      }
      return r;
    }
  )
), Xn = No ? (
  // Native
  function(t, r) {
    return t.codePointAt(r);
  }
) : (
  // IE 11
  function(t, r) {
    var n = t.length;
    if (!(r < 0 || r >= n)) {
      var s = t.charCodeAt(r), i;
      return s < 55296 || s > 56319 || r + 1 === n || (i = t.charCodeAt(r + 1)) < 56320 || i > 57343 ? s : (s - 55296 << 10) + (i - 56320) + 65536;
    }
  }
), Uo = Ho ? (
  // Native
  function(t) {
    return t.trimStart();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(Ao, "");
  }
), Mo = Io ? (
  // Native
  function(t) {
    return t.trimEnd();
  }
) : (
  // Ponyfill
  function(t) {
    return t.replace(Oo, "");
  }
);
function zn(e, t) {
  return new RegExp(e, t);
}
var Lt;
if (Ht) {
  var Mr = zn("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  Lt = function(t, r) {
    var n;
    Mr.lastIndex = r;
    var s = Mr.exec(t);
    return (n = s[1]) !== null && n !== void 0 ? n : "";
  };
} else
  Lt = function(t, r) {
    for (var n = []; ; ) {
      var s = Xn(t, r);
      if (s === void 0 || Jn(s) || Vo(s))
        break;
      n.push(s), r += s >= 65536 ? 2 : 1;
    }
    return It.apply(void 0, n);
  };
var ko = (
  /** @class */
  function() {
    function e(t, r) {
      r === void 0 && (r = {}), this.message = t, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!r.ignoreTag, this.locale = r.locale, this.requiresOtherClause = !!r.requiresOtherClause, this.shouldParseSkeletons = !!r.shouldParseSkeletons;
    }
    return e.prototype.parse = function() {
      if (this.offset() !== 0)
        throw Error("parser can only be used once");
      return this.parseMessage(0, "", !1);
    }, e.prototype.parseMessage = function(t, r, n) {
      for (var s = []; !this.isEOF(); ) {
        var i = this.char();
        if (i === 123) {
          var o = this.parseArgument(t, n);
          if (o.err)
            return o;
          s.push(o.val);
        } else {
          if (i === 125 && t > 0)
            break;
          if (i === 35 && (r === "plural" || r === "selectordinal")) {
            var u = this.clonePosition();
            this.bump(), s.push({
              type: H.pound,
              location: C(u, this.clonePosition())
            });
          } else if (i === 60 && !this.ignoreTag && this.peek() === 47) {
            if (n)
              break;
            return this.error(A.UNMATCHED_CLOSING_TAG, C(this.clonePosition(), this.clonePosition()));
          } else if (i === 60 && !this.ignoreTag && Dt(this.peek() || 0)) {
            var o = this.parseTag(t, r);
            if (o.err)
              return o;
            s.push(o.val);
          } else {
            var o = this.parseLiteral(t, r);
            if (o.err)
              return o;
            s.push(o.val);
          }
        }
      }
      return { val: s, err: null };
    }, e.prototype.parseTag = function(t, r) {
      var n = this.clonePosition();
      this.bump();
      var s = this.parseTagName();
      if (this.bumpSpace(), this.bumpIf("/>"))
        return {
          val: {
            type: H.literal,
            value: "<".concat(s, "/>"),
            location: C(n, this.clonePosition())
          },
          err: null
        };
      if (this.bumpIf(">")) {
        var i = this.parseMessage(t + 1, r, !0);
        if (i.err)
          return i;
        var o = i.val, u = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !Dt(this.char()))
            return this.error(A.INVALID_TAG, C(u, this.clonePosition()));
          var c = this.clonePosition(), l = this.parseTagName();
          return s !== l ? this.error(A.UNMATCHED_CLOSING_TAG, C(c, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
            val: {
              type: H.tag,
              value: s,
              children: o,
              location: C(n, this.clonePosition())
            },
            err: null
          } : this.error(A.INVALID_TAG, C(u, this.clonePosition())));
        } else
          return this.error(A.UNCLOSED_TAG, C(n, this.clonePosition()));
      } else
        return this.error(A.INVALID_TAG, C(n, this.clonePosition()));
    }, e.prototype.parseTagName = function() {
      var t = this.offset();
      for (this.bump(); !this.isEOF() && Go(this.char()); )
        this.bump();
      return this.message.slice(t, this.offset());
    }, e.prototype.parseLiteral = function(t, r) {
      for (var n = this.clonePosition(), s = ""; ; ) {
        var i = this.tryParseQuote(r);
        if (i) {
          s += i;
          continue;
        }
        var o = this.tryParseUnquoted(t, r);
        if (o) {
          s += o;
          continue;
        }
        var u = this.tryParseLeftAngleBracket();
        if (u) {
          s += u;
          continue;
        }
        break;
      }
      var c = C(n, this.clonePosition());
      return {
        val: { type: H.literal, value: s, location: c },
        err: null
      };
    }, e.prototype.tryParseLeftAngleBracket = function() {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !jo(this.peek() || 0)) ? (this.bump(), "<") : null;
    }, e.prototype.tryParseQuote = function(t) {
      if (this.isEOF() || this.char() !== 39)
        return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (t === "plural" || t === "selectordinal")
            break;
          return null;
        default:
          return null;
      }
      this.bump();
      var r = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var n = this.char();
        if (n === 39)
          if (this.peek() === 39)
            r.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else
          r.push(n);
        this.bump();
      }
      return It.apply(void 0, r);
    }, e.prototype.tryParseUnquoted = function(t, r) {
      if (this.isEOF())
        return null;
      var n = this.char();
      return n === 60 || n === 123 || n === 35 && (r === "plural" || r === "selectordinal") || n === 125 && t > 0 ? null : (this.bump(), It(n));
    }, e.prototype.parseArgument = function(t, r) {
      var n = this.clonePosition();
      if (this.bump(), this.bumpSpace(), this.isEOF())
        return this.error(A.EXPECT_ARGUMENT_CLOSING_BRACE, C(n, this.clonePosition()));
      if (this.char() === 125)
        return this.bump(), this.error(A.EMPTY_ARGUMENT, C(n, this.clonePosition()));
      var s = this.parseIdentifierIfPossible().value;
      if (!s)
        return this.error(A.MALFORMED_ARGUMENT, C(n, this.clonePosition()));
      if (this.bumpSpace(), this.isEOF())
        return this.error(A.EXPECT_ARGUMENT_CLOSING_BRACE, C(n, this.clonePosition()));
      switch (this.char()) {
        case 125:
          return this.bump(), {
            val: {
              type: H.argument,
              // value does not include the opening and closing braces.
              value: s,
              location: C(n, this.clonePosition())
            },
            err: null
          };
        case 44:
          return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(A.EXPECT_ARGUMENT_CLOSING_BRACE, C(n, this.clonePosition())) : this.parseArgumentOptions(t, r, s, n);
        default:
          return this.error(A.MALFORMED_ARGUMENT, C(n, this.clonePosition()));
      }
    }, e.prototype.parseIdentifierIfPossible = function() {
      var t = this.clonePosition(), r = this.offset(), n = Lt(this.message, r), s = r + n.length;
      this.bumpTo(s);
      var i = this.clonePosition(), o = C(t, i);
      return { value: n, location: o };
    }, e.prototype.parseArgumentOptions = function(t, r, n, s) {
      var i, o = this.clonePosition(), u = this.parseIdentifierIfPossible().value, c = this.clonePosition();
      switch (u) {
        case "":
          return this.error(A.EXPECT_ARGUMENT_TYPE, C(o, c));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var l = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var h = this.clonePosition(), d = this.parseSimpleArgStyleIfPossible();
            if (d.err)
              return d;
            var m = Mo(d.val);
            if (m.length === 0)
              return this.error(A.EXPECT_ARGUMENT_STYLE, C(this.clonePosition(), this.clonePosition()));
            var T = C(h, this.clonePosition());
            l = { style: m, styleLocation: T };
          }
          var E = this.tryParseArgumentClose(s);
          if (E.err)
            return E;
          var y = C(s, this.clonePosition());
          if (l && Fr(l == null ? void 0 : l.style, "::", 0)) {
            var g = Uo(l.style.slice(2));
            if (u === "number") {
              var d = this.parseNumberSkeletonFromString(g, l.styleLocation);
              return d.err ? d : {
                val: { type: H.number, value: n, location: y, style: d.val },
                err: null
              };
            } else {
              if (g.length === 0)
                return this.error(A.EXPECT_DATE_TIME_SKELETON, y);
              var O = g;
              this.locale && (O = wo(g, this.locale));
              var m = {
                type: pe.dateTime,
                pattern: O,
                location: l.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? Eo(O) : {}
              }, w = u === "date" ? H.date : H.time;
              return {
                val: { type: w, value: n, location: y, style: m },
                err: null
              };
            }
          }
          return {
            val: {
              type: u === "number" ? H.number : u === "date" ? H.date : H.time,
              value: n,
              location: y,
              style: (i = l == null ? void 0 : l.style) !== null && i !== void 0 ? i : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var x = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(","))
            return this.error(A.EXPECT_SELECT_ARGUMENT_OPTIONS, C(x, qe({}, x)));
          this.bumpSpace();
          var L = this.parseIdentifierIfPossible(), M = 0;
          if (u !== "select" && L.value === "offset") {
            if (!this.bumpIf(":"))
              return this.error(A.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, C(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var d = this.tryParseDecimalInteger(A.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, A.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (d.err)
              return d;
            this.bumpSpace(), L = this.parseIdentifierIfPossible(), M = d.val;
          }
          var j = this.tryParsePluralOrSelectOptions(t, u, r, L);
          if (j.err)
            return j;
          var E = this.tryParseArgumentClose(s);
          if (E.err)
            return E;
          var k = C(s, this.clonePosition());
          return u === "select" ? {
            val: {
              type: H.select,
              value: n,
              options: Ur(j.val),
              location: k
            },
            err: null
          } : {
            val: {
              type: H.plural,
              value: n,
              options: Ur(j.val),
              offset: M,
              pluralType: u === "plural" ? "cardinal" : "ordinal",
              location: k
            },
            err: null
          };
        }
        default:
          return this.error(A.INVALID_ARGUMENT_TYPE, C(o, c));
      }
    }, e.prototype.tryParseArgumentClose = function(t) {
      return this.isEOF() || this.char() !== 125 ? this.error(A.EXPECT_ARGUMENT_CLOSING_BRACE, C(t, this.clonePosition())) : (this.bump(), { val: !0, err: null });
    }, e.prototype.parseSimpleArgStyleIfPossible = function() {
      for (var t = 0, r = this.clonePosition(); !this.isEOF(); ) {
        var n = this.char();
        switch (n) {
          case 39: {
            this.bump();
            var s = this.clonePosition();
            if (!this.bumpUntil("'"))
              return this.error(A.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, C(s, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            t += 1, this.bump();
            break;
          }
          case 125: {
            if (t > 0)
              t -= 1;
            else
              return {
                val: this.message.slice(r.offset, this.offset()),
                err: null
              };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(r.offset, this.offset()),
        err: null
      };
    }, e.prototype.parseNumberSkeletonFromString = function(t, r) {
      var n = [];
      try {
        n = vo(t);
      } catch {
        return this.error(A.INVALID_NUMBER_SKELETON, r);
      }
      return {
        val: {
          type: pe.number,
          tokens: n,
          location: r,
          parsedOptions: this.shouldParseSkeletons ? _o(n) : {}
        },
        err: null
      };
    }, e.prototype.tryParsePluralOrSelectOptions = function(t, r, n, s) {
      for (var i, o = !1, u = [], c = /* @__PURE__ */ new Set(), l = s.value, h = s.location; ; ) {
        if (l.length === 0) {
          var d = this.clonePosition();
          if (r !== "select" && this.bumpIf("=")) {
            var m = this.tryParseDecimalInteger(A.EXPECT_PLURAL_ARGUMENT_SELECTOR, A.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (m.err)
              return m;
            h = C(d, this.clonePosition()), l = this.message.slice(d.offset, this.offset());
          } else
            break;
        }
        if (c.has(l))
          return this.error(r === "select" ? A.DUPLICATE_SELECT_ARGUMENT_SELECTOR : A.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, h);
        l === "other" && (o = !0), this.bumpSpace();
        var T = this.clonePosition();
        if (!this.bumpIf("{"))
          return this.error(r === "select" ? A.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : A.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, C(this.clonePosition(), this.clonePosition()));
        var E = this.parseMessage(t + 1, r, n);
        if (E.err)
          return E;
        var y = this.tryParseArgumentClose(T);
        if (y.err)
          return y;
        u.push([
          l,
          {
            value: E.val,
            location: C(T, this.clonePosition())
          }
        ]), c.add(l), this.bumpSpace(), i = this.parseIdentifierIfPossible(), l = i.value, h = i.location;
      }
      return u.length === 0 ? this.error(r === "select" ? A.EXPECT_SELECT_ARGUMENT_SELECTOR : A.EXPECT_PLURAL_ARGUMENT_SELECTOR, C(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !o ? this.error(A.MISSING_OTHER_CLAUSE, C(this.clonePosition(), this.clonePosition())) : { val: u, err: null };
    }, e.prototype.tryParseDecimalInteger = function(t, r) {
      var n = 1, s = this.clonePosition();
      this.bumpIf("+") || this.bumpIf("-") && (n = -1);
      for (var i = !1, o = 0; !this.isEOF(); ) {
        var u = this.char();
        if (u >= 48 && u <= 57)
          i = !0, o = o * 10 + (u - 48), this.bump();
        else
          break;
      }
      var c = C(s, this.clonePosition());
      return i ? (o *= n, Do(o) ? { val: o, err: null } : this.error(r, c)) : this.error(t, c);
    }, e.prototype.offset = function() {
      return this.position.offset;
    }, e.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    }, e.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    }, e.prototype.char = function() {
      var t = this.position.offset;
      if (t >= this.message.length)
        throw Error("out of bound");
      var r = Xn(this.message, t);
      if (r === void 0)
        throw Error("Offset ".concat(t, " is at invalid UTF-16 code unit boundary"));
      return r;
    }, e.prototype.error = function(t, r) {
      return {
        val: null,
        err: {
          kind: t,
          message: this.message,
          location: r
        }
      };
    }, e.prototype.bump = function() {
      if (!this.isEOF()) {
        var t = this.char();
        t === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += t < 65536 ? 1 : 2);
      }
    }, e.prototype.bumpIf = function(t) {
      if (Fr(this.message, t, this.offset())) {
        for (var r = 0; r < t.length; r++)
          this.bump();
        return !0;
      }
      return !1;
    }, e.prototype.bumpUntil = function(t) {
      var r = this.offset(), n = this.message.indexOf(t, r);
      return n >= 0 ? (this.bumpTo(n), !0) : (this.bumpTo(this.message.length), !1);
    }, e.prototype.bumpTo = function(t) {
      if (this.offset() > t)
        throw Error("targetOffset ".concat(t, " must be greater than or equal to the current offset ").concat(this.offset()));
      for (t = Math.min(t, this.message.length); ; ) {
        var r = this.offset();
        if (r === t)
          break;
        if (r > t)
          throw Error("targetOffset ".concat(t, " is at invalid UTF-16 code unit boundary"));
        if (this.bump(), this.isEOF())
          break;
      }
    }, e.prototype.bumpSpace = function() {
      for (; !this.isEOF() && Jn(this.char()); )
        this.bump();
    }, e.prototype.peek = function() {
      if (this.isEOF())
        return null;
      var t = this.char(), r = this.offset(), n = this.message.charCodeAt(r + (t >= 65536 ? 2 : 1));
      return n ?? null;
    }, e;
  }()
);
function Dt(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function jo(e) {
  return Dt(e) || e === 47;
}
function Go(e) {
  return e === 45 || e === 46 || e >= 48 && e <= 57 || e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90 || e == 183 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
}
function Jn(e) {
  return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
function Vo(e) {
  return e >= 33 && e <= 35 || e === 36 || e >= 37 && e <= 39 || e === 40 || e === 41 || e === 42 || e === 43 || e === 44 || e === 45 || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || e === 91 || e === 92 || e === 93 || e === 94 || e === 96 || e === 123 || e === 124 || e === 125 || e === 126 || e === 161 || e >= 162 && e <= 165 || e === 166 || e === 167 || e === 169 || e === 171 || e === 172 || e === 174 || e === 176 || e === 177 || e === 182 || e === 187 || e === 191 || e === 215 || e === 247 || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || e === 8216 || e === 8217 || e === 8218 || e >= 8219 && e <= 8220 || e === 8221 || e === 8222 || e === 8223 || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || e === 8249 || e === 8250 || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || e === 8260 || e === 8261 || e === 8262 || e >= 8263 && e <= 8273 || e === 8274 || e === 8275 || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || e === 8608 || e >= 8609 && e <= 8610 || e === 8611 || e >= 8612 && e <= 8613 || e === 8614 || e >= 8615 && e <= 8621 || e === 8622 || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || e === 8658 || e === 8659 || e === 8660 || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || e === 8968 || e === 8969 || e === 8970 || e === 8971 || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || e === 9001 || e === 9002 || e >= 9003 && e <= 9083 || e === 9084 || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || e === 9655 || e >= 9656 && e <= 9664 || e === 9665 || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || e === 9839 || e >= 9840 && e <= 10087 || e === 10088 || e === 10089 || e === 10090 || e === 10091 || e === 10092 || e === 10093 || e === 10094 || e === 10095 || e === 10096 || e === 10097 || e === 10098 || e === 10099 || e === 10100 || e === 10101 || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || e === 10181 || e === 10182 || e >= 10183 && e <= 10213 || e === 10214 || e === 10215 || e === 10216 || e === 10217 || e === 10218 || e === 10219 || e === 10220 || e === 10221 || e === 10222 || e === 10223 || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || e === 10627 || e === 10628 || e === 10629 || e === 10630 || e === 10631 || e === 10632 || e === 10633 || e === 10634 || e === 10635 || e === 10636 || e === 10637 || e === 10638 || e === 10639 || e === 10640 || e === 10641 || e === 10642 || e === 10643 || e === 10644 || e === 10645 || e === 10646 || e === 10647 || e === 10648 || e >= 10649 && e <= 10711 || e === 10712 || e === 10713 || e === 10714 || e === 10715 || e >= 10716 && e <= 10747 || e === 10748 || e === 10749 || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || e === 11158 || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || e === 11778 || e === 11779 || e === 11780 || e === 11781 || e >= 11782 && e <= 11784 || e === 11785 || e === 11786 || e === 11787 || e === 11788 || e === 11789 || e >= 11790 && e <= 11798 || e === 11799 || e >= 11800 && e <= 11801 || e === 11802 || e === 11803 || e === 11804 || e === 11805 || e >= 11806 && e <= 11807 || e === 11808 || e === 11809 || e === 11810 || e === 11811 || e === 11812 || e === 11813 || e === 11814 || e === 11815 || e === 11816 || e === 11817 || e >= 11818 && e <= 11822 || e === 11823 || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || e === 11840 || e === 11841 || e === 11842 || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || e === 11858 || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || e === 12296 || e === 12297 || e === 12298 || e === 12299 || e === 12300 || e === 12301 || e === 12302 || e === 12303 || e === 12304 || e === 12305 || e >= 12306 && e <= 12307 || e === 12308 || e === 12309 || e === 12310 || e === 12311 || e === 12312 || e === 12313 || e === 12314 || e === 12315 || e === 12316 || e === 12317 || e >= 12318 && e <= 12319 || e === 12320 || e === 12336 || e === 64830 || e === 64831 || e >= 65093 && e <= 65094;
}
function Ft(e) {
  e.forEach(function(t) {
    if (delete t.location, Mn(t) || kn(t))
      for (var r in t.options)
        delete t.options[r].location, Ft(t.options[r].value);
    else
      Dn(t) && Gn(t.style) || (Fn(t) || Un(t)) && Nt(t.style) ? delete t.style.location : jn(t) && Ft(t.children);
  });
}
function Wo(e, t) {
  t === void 0 && (t = {}), t = qe({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, t);
  var r = new ko(e, t).parse();
  if (r.err) {
    var n = SyntaxError(A[r.err.kind]);
    throw n.location = r.err.location, n.originalMessage = r.err.message, n;
  }
  return t != null && t.captureLocation || Ft(r.val), r.val;
}
function mt(e, t) {
  var r = t && t.cache ? t.cache : Yo, n = t && t.serializer ? t.serializer : Jo, s = t && t.strategy ? t.strategy : qo;
  return s(e, {
    cache: r,
    serializer: n
  });
}
function $o(e) {
  return e == null || typeof e == "number" || typeof e == "boolean";
}
function Yn(e, t, r, n) {
  var s = $o(n) ? n : r(n), i = t.get(s);
  return typeof i > "u" && (i = e.call(this, n), t.set(s, i)), i;
}
function Zn(e, t, r) {
  var n = Array.prototype.slice.call(arguments, 3), s = r(n), i = t.get(s);
  return typeof i > "u" && (i = e.apply(this, n), t.set(s, i)), i;
}
function $t(e, t, r, n, s) {
  return r.bind(t, e, n, s);
}
function qo(e, t) {
  var r = e.length === 1 ? Yn : Zn;
  return $t(e, this, r, t.cache.create(), t.serializer);
}
function Xo(e, t) {
  return $t(e, this, Zn, t.cache.create(), t.serializer);
}
function zo(e, t) {
  return $t(e, this, Yn, t.cache.create(), t.serializer);
}
var Jo = function() {
  return JSON.stringify(arguments);
};
function qt() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
qt.prototype.get = function(e) {
  return this.cache[e];
};
qt.prototype.set = function(e, t) {
  this.cache[e] = t;
};
var Yo = {
  create: function() {
    return new qt();
  }
}, bt = {
  variadic: Xo,
  monadic: zo
}, me;
(function(e) {
  e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
})(me || (me = {}));
var Ke = (
  /** @class */
  function(e) {
    Qe(t, e);
    function t(r, n, s) {
      var i = e.call(this, r) || this;
      return i.code = n, i.originalMessage = s, i;
    }
    return t.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, t;
  }(Error)
), kr = (
  /** @class */
  function(e) {
    Qe(t, e);
    function t(r, n, s, i) {
      return e.call(this, 'Invalid values for "'.concat(r, '": "').concat(n, '". Options are "').concat(Object.keys(s).join('", "'), '"'), me.INVALID_VALUE, i) || this;
    }
    return t;
  }(Ke)
), Zo = (
  /** @class */
  function(e) {
    Qe(t, e);
    function t(r, n, s) {
      return e.call(this, 'Value for "'.concat(r, '" must be of type ').concat(n), me.INVALID_VALUE, s) || this;
    }
    return t;
  }(Ke)
), Qo = (
  /** @class */
  function(e) {
    Qe(t, e);
    function t(r, n) {
      return e.call(this, 'The intl string context variable "'.concat(r, '" was not provided to the string "').concat(n, '"'), me.MISSING_VALUE, n) || this;
    }
    return t;
  }(Ke)
), W;
(function(e) {
  e[e.literal = 0] = "literal", e[e.object = 1] = "object";
})(W || (W = {}));
function Ko(e) {
  return e.length < 2 ? e : e.reduce(function(t, r) {
    var n = t[t.length - 1];
    return !n || n.type !== W.literal || r.type !== W.literal ? t.push(r) : n.value += r.value, t;
  }, []);
}
function ea(e) {
  return typeof e == "function";
}
function je(e, t, r, n, s, i, o) {
  if (e.length === 1 && Hr(e[0]))
    return [
      {
        type: W.literal,
        value: e[0].value
      }
    ];
  for (var u = [], c = 0, l = e; c < l.length; c++) {
    var h = l[c];
    if (Hr(h)) {
      u.push({
        type: W.literal,
        value: h.value
      });
      continue;
    }
    if (bo(h)) {
      typeof i == "number" && u.push({
        type: W.literal,
        value: r.getNumberFormat(t).format(i)
      });
      continue;
    }
    var d = h.value;
    if (!(s && d in s))
      throw new Qo(d, o);
    var m = s[d];
    if (mo(h)) {
      (!m || typeof m == "string" || typeof m == "number") && (m = typeof m == "string" || typeof m == "number" ? String(m) : ""), u.push({
        type: typeof m == "string" ? W.literal : W.object,
        value: m
      });
      continue;
    }
    if (Fn(h)) {
      var T = typeof h.style == "string" ? n.date[h.style] : Nt(h.style) ? h.style.parsedOptions : void 0;
      u.push({
        type: W.literal,
        value: r.getDateTimeFormat(t, T).format(m)
      });
      continue;
    }
    if (Un(h)) {
      var T = typeof h.style == "string" ? n.time[h.style] : Nt(h.style) ? h.style.parsedOptions : n.time.medium;
      u.push({
        type: W.literal,
        value: r.getDateTimeFormat(t, T).format(m)
      });
      continue;
    }
    if (Dn(h)) {
      var T = typeof h.style == "string" ? n.number[h.style] : Gn(h.style) ? h.style.parsedOptions : void 0;
      T && T.scale && (m = m * (T.scale || 1)), u.push({
        type: W.literal,
        value: r.getNumberFormat(t, T).format(m)
      });
      continue;
    }
    if (jn(h)) {
      var E = h.children, y = h.value, g = s[y];
      if (!ea(g))
        throw new Zo(y, "function", o);
      var O = je(E, t, r, n, s, i), w = g(O.map(function(M) {
        return M.value;
      }));
      Array.isArray(w) || (w = [w]), u.push.apply(u, w.map(function(M) {
        return {
          type: typeof M == "string" ? W.literal : W.object,
          value: M
        };
      }));
    }
    if (Mn(h)) {
      var x = h.options[m] || h.options.other;
      if (!x)
        throw new kr(h.value, m, Object.keys(h.options), o);
      u.push.apply(u, je(x.value, t, r, n, s));
      continue;
    }
    if (kn(h)) {
      var x = h.options["=".concat(m)];
      if (!x) {
        if (!Intl.PluralRules)
          throw new Ke(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, me.MISSING_INTL_API, o);
        var L = r.getPluralRules(t, { type: h.pluralType }).select(m - (h.offset || 0));
        x = h.options[L] || h.options.other;
      }
      if (!x)
        throw new kr(h.value, m, Object.keys(h.options), o);
      u.push.apply(u, je(x.value, t, r, n, s, m - (h.offset || 0)));
      continue;
    }
  }
  return Ko(u);
}
function ta(e, t) {
  return t ? ee(ee(ee({}, e || {}), t || {}), Object.keys(e).reduce(function(r, n) {
    return r[n] = ee(ee({}, e[n]), t[n] || {}), r;
  }, {})) : e;
}
function ra(e, t) {
  return t ? Object.keys(e).reduce(function(r, n) {
    return r[n] = ta(e[n], t[n]), r;
  }, ee({}, e)) : e;
}
function gt(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, r) {
          e[t] = r;
        }
      };
    }
  };
}
function na(e) {
  return e === void 0 && (e = {
    number: {},
    dateTime: {},
    pluralRules: {}
  }), {
    getNumberFormat: mt(function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return new ((t = Intl.NumberFormat).bind.apply(t, dt([void 0], r, !1)))();
    }, {
      cache: gt(e.number),
      strategy: bt.variadic
    }),
    getDateTimeFormat: mt(function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return new ((t = Intl.DateTimeFormat).bind.apply(t, dt([void 0], r, !1)))();
    }, {
      cache: gt(e.dateTime),
      strategy: bt.variadic
    }),
    getPluralRules: mt(function() {
      for (var t, r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return new ((t = Intl.PluralRules).bind.apply(t, dt([void 0], r, !1)))();
    }, {
      cache: gt(e.pluralRules),
      strategy: bt.variadic
    })
  };
}
var sa = (
  /** @class */
  function() {
    function e(t, r, n, s) {
      var i = this;
      if (r === void 0 && (r = e.defaultLocale), this.formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
      }, this.format = function(c) {
        var l = i.formatToParts(c);
        if (l.length === 1)
          return l[0].value;
        var h = l.reduce(function(d, m) {
          return !d.length || m.type !== W.literal || typeof d[d.length - 1] != "string" ? d.push(m.value) : d[d.length - 1] += m.value, d;
        }, []);
        return h.length <= 1 ? h[0] || "" : h;
      }, this.formatToParts = function(c) {
        return je(i.ast, i.locales, i.formatters, i.formats, c, void 0, i.message);
      }, this.resolvedOptions = function() {
        var c;
        return {
          locale: ((c = i.resolvedLocale) === null || c === void 0 ? void 0 : c.toString()) || Intl.NumberFormat.supportedLocalesOf(i.locales)[0]
        };
      }, this.getAst = function() {
        return i.ast;
      }, this.locales = r, this.resolvedLocale = e.resolveLocale(r), typeof t == "string") {
        if (this.message = t, !e.__parse)
          throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
        var o = s || {};
        o.formatters;
        var u = po(o, ["formatters"]);
        this.ast = e.__parse(t, ee(ee({}, u), { locale: this.resolvedLocale }));
      } else
        this.ast = t;
      if (!Array.isArray(this.ast))
        throw new TypeError("A message must be provided as a String or AST.");
      this.formats = ra(e.formats, n), this.formatters = s && s.formatters || na(this.formatterCache);
    }
    return Object.defineProperty(e, "defaultLocale", {
      get: function() {
        return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
      },
      enumerable: !1,
      configurable: !0
    }), e.memoizedDefaultLocale = null, e.resolveLocale = function(t) {
      if (!(typeof Intl.Locale > "u")) {
        var r = Intl.NumberFormat.supportedLocalesOf(t);
        return r.length > 0 ? new Intl.Locale(r[0]) : new Intl.Locale(typeof t == "string" ? t : t[0]);
      }
    }, e.__parse = Wo, e.formats = {
      number: {
        integer: {
          maximumFractionDigits: 0
        },
        currency: {
          style: "currency"
        },
        percent: {
          style: "percent"
        }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    }, e;
  }()
);
const Qn = (e, t, r) => (n, s) => {
  if (n === void 0)
    return "";
  const i = t(n);
  if (r && (n = r(n)), !i)
    return console.warn(
      `Can't find namespace. Make sure you pass all used namespaces in the getBaseServerSideProps. Some troubles with "${n}"`
    ), "";
  for (let o of i) {
    const u = e(n, { ns: o, ...s });
    if (u && u !== n)
      return u;
  }
  return n;
}, ia = (e, t, r) => (n, s, i) => {
  const o = Qn(e, t, r);
  try {
    const u = o(n, i);
    if (!u)
      return "";
    const l = new sa(u).format(s);
    return Array.isArray(l) ? l.join("") : l;
  } catch (u) {
    return console.error(`tICU formatting error for key "${n}":`, u), "";
  }
}, Fa = ({
  useTranslation: e,
  defaultNamespaces: t,
  namespaceMapper: r,
  assetKeyMapper: n
}) => function(i = []) {
  const { t: o, ...u } = e([...t, ...i]), c = xt(Qn(o, r, n), [o]), l = xt(ia(o, r, n), [
    o
  ]);
  return { t: c, tICU: l, ...u };
}, Ua = (e) => {
  try {
    const t = new URL(e);
    return t.protocol === "http:" || t.protocol === "https:";
  } catch {
    return !1;
  }
};
function Ma(e) {
  return /(?:^|\.)systeme\.(?:io|club|local)$/i.test(e);
}
const ka = (e, t, r = 2) => {
  if (t === 0)
    return jr(0);
  const n = e / t * 100;
  return jr(parseFloat(n.toFixed(r)));
}, jr = (e) => e;
function ja() {
  if (typeof Node == "function" && Node.prototype) {
    const e = Node.prototype.removeChild;
    Node.prototype.removeChild = function(r) {
      return r.parentNode !== this ? (console && console.error("Cannot remove a child from a different parent", r, this), r) : e.apply(this, arguments);
    };
    const t = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function(r, n) {
      return n && n.parentNode !== this ? (console && console.error(
        "Cannot insert before a reference node from a different parent",
        n,
        this
      ), r) : t.apply(this, arguments);
    };
  }
}
const Ga = (e, t) => {
  Zr(() => {
    t(e);
  }, [e]);
};
function Ge() {
  return typeof window < "u" && typeof document < "u";
}
const Va = (e, t = {
  parser: (r) => JSON.parse(r),
  stringifier: (r) => JSON.stringify(r)
}) => ({
  setItem: (i) => {
    Ge() && localStorage.setItem(e, t.stringifier(i));
  },
  getItem: () => {
    if (Ge()) {
      const i = localStorage.getItem(e);
      return i ? t.parser(i) : null;
    }
    return null;
  },
  removeItem: () => {
    Ge() && localStorage.removeItem(e);
  }
});
var oa = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, re = function(e) {
  return typeof e == "string" ? e.length > 0 : typeof e == "number";
}, G = function(e, t, r) {
  return t === void 0 && (t = 0), r === void 0 && (r = Math.pow(10, t)), Math.round(r * e) / r + 0;
}, Y = function(e, t, r) {
  return t === void 0 && (t = 0), r === void 0 && (r = 1), e > r ? r : e > t ? e : t;
}, Kn = function(e) {
  return (e = isFinite(e) ? e % 360 : 0) > 0 ? e : e + 360;
}, Gr = function(e) {
  return { r: Y(e.r, 0, 255), g: Y(e.g, 0, 255), b: Y(e.b, 0, 255), a: Y(e.a) };
}, Et = function(e) {
  return { r: G(e.r), g: G(e.g), b: G(e.b), a: G(e.a, 3) };
}, aa = /^#([0-9a-f]{3,8})$/i, Le = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, es = function(e) {
  var t = e.r, r = e.g, n = e.b, s = e.a, i = Math.max(t, r, n), o = i - Math.min(t, r, n), u = o ? i === t ? (r - n) / o : i === r ? 2 + (n - t) / o : 4 + (t - r) / o : 0;
  return { h: 60 * (u < 0 ? u + 6 : u), s: i ? o / i * 100 : 0, v: i / 255 * 100, a: s };
}, ts = function(e) {
  var t = e.h, r = e.s, n = e.v, s = e.a;
  t = t / 360 * 6, r /= 100, n /= 100;
  var i = Math.floor(t), o = n * (1 - r), u = n * (1 - (t - i) * r), c = n * (1 - (1 - t + i) * r), l = i % 6;
  return { r: 255 * [n, u, o, o, c, n][l], g: 255 * [c, n, n, u, o, o][l], b: 255 * [o, o, c, n, n, u][l], a: s };
}, Vr = function(e) {
  return { h: Kn(e.h), s: Y(e.s, 0, 100), l: Y(e.l, 0, 100), a: Y(e.a) };
}, Wr = function(e) {
  return { h: G(e.h), s: G(e.s), l: G(e.l), a: G(e.a, 3) };
}, $r = function(e) {
  return ts((r = (t = e).s, { h: t.h, s: (r *= ((n = t.l) < 50 ? n : 100 - n) / 100) > 0 ? 2 * r / (n + r) * 100 : 0, v: n + r, a: t.a }));
  var t, r, n;
}, we = function(e) {
  return { h: (t = es(e)).h, s: (s = (200 - (r = t.s)) * (n = t.v) / 100) > 0 && s < 200 ? r * n / 100 / (s <= 100 ? s : 200 - s) * 100 : 0, l: s / 2, a: t.a };
  var t, r, n, s;
}, ua = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, la = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, ca = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, ha = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, qr = { string: [[function(e) {
  var t = aa.exec(e);
  return t ? (e = t[1]).length <= 4 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? G(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : e.length === 6 || e.length === 8 ? { r: parseInt(e.substr(0, 2), 16), g: parseInt(e.substr(2, 2), 16), b: parseInt(e.substr(4, 2), 16), a: e.length === 8 ? G(parseInt(e.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(e) {
  var t = ca.exec(e) || ha.exec(e);
  return t ? t[2] !== t[4] || t[4] !== t[6] ? null : Gr({ r: Number(t[1]) / (t[2] ? 100 / 255 : 1), g: Number(t[3]) / (t[4] ? 100 / 255 : 1), b: Number(t[5]) / (t[6] ? 100 / 255 : 1), a: t[7] === void 0 ? 1 : Number(t[7]) / (t[8] ? 100 : 1) }) : null;
}, "rgb"], [function(e) {
  var t = ua.exec(e) || la.exec(e);
  if (!t)
    return null;
  var r, n, s = Vr({ h: (r = t[1], n = t[2], n === void 0 && (n = "deg"), Number(r) * (oa[n] || 1)), s: Number(t[3]), l: Number(t[4]), a: t[5] === void 0 ? 1 : Number(t[5]) / (t[6] ? 100 : 1) });
  return $r(s);
}, "hsl"]], object: [[function(e) {
  var t = e.r, r = e.g, n = e.b, s = e.a, i = s === void 0 ? 1 : s;
  return re(t) && re(r) && re(n) ? Gr({ r: Number(t), g: Number(r), b: Number(n), a: Number(i) }) : null;
}, "rgb"], [function(e) {
  var t = e.h, r = e.s, n = e.l, s = e.a, i = s === void 0 ? 1 : s;
  if (!re(t) || !re(r) || !re(n))
    return null;
  var o = Vr({ h: Number(t), s: Number(r), l: Number(n), a: Number(i) });
  return $r(o);
}, "hsl"], [function(e) {
  var t = e.h, r = e.s, n = e.v, s = e.a, i = s === void 0 ? 1 : s;
  if (!re(t) || !re(r) || !re(n))
    return null;
  var o = function(u) {
    return { h: Kn(u.h), s: Y(u.s, 0, 100), v: Y(u.v, 0, 100), a: Y(u.a) };
  }({ h: Number(t), s: Number(r), v: Number(n), a: Number(i) });
  return ts(o);
}, "hsv"]] }, Xr = function(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r][0](e);
    if (n)
      return [n, t[r][1]];
  }
  return [null, void 0];
}, fa = function(e) {
  return typeof e == "string" ? Xr(e.trim(), qr.string) : typeof e == "object" && e !== null ? Xr(e, qr.object) : [null, void 0];
}, yt = function(e, t) {
  var r = we(e);
  return { h: r.h, s: Y(r.s + 100 * t, 0, 100), l: r.l, a: r.a };
}, vt = function(e) {
  return (299 * e.r + 587 * e.g + 114 * e.b) / 1e3 / 255;
}, zr = function(e, t) {
  var r = we(e);
  return { h: r.h, s: r.s, l: Y(r.l + 100 * t, 0, 100), a: r.a };
}, Jr = function() {
  function e(t) {
    this.parsed = fa(t)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return e.prototype.isValid = function() {
    return this.parsed !== null;
  }, e.prototype.brightness = function() {
    return G(vt(this.rgba), 2);
  }, e.prototype.isDark = function() {
    return vt(this.rgba) < 0.5;
  }, e.prototype.isLight = function() {
    return vt(this.rgba) >= 0.5;
  }, e.prototype.toHex = function() {
    return t = Et(this.rgba), r = t.r, n = t.g, s = t.b, o = (i = t.a) < 1 ? Le(G(255 * i)) : "", "#" + Le(r) + Le(n) + Le(s) + o;
    var t, r, n, s, i, o;
  }, e.prototype.toRgb = function() {
    return Et(this.rgba);
  }, e.prototype.toRgbString = function() {
    return t = Et(this.rgba), r = t.r, n = t.g, s = t.b, (i = t.a) < 1 ? "rgba(" + r + ", " + n + ", " + s + ", " + i + ")" : "rgb(" + r + ", " + n + ", " + s + ")";
    var t, r, n, s, i;
  }, e.prototype.toHsl = function() {
    return Wr(we(this.rgba));
  }, e.prototype.toHslString = function() {
    return t = Wr(we(this.rgba)), r = t.h, n = t.s, s = t.l, (i = t.a) < 1 ? "hsla(" + r + ", " + n + "%, " + s + "%, " + i + ")" : "hsl(" + r + ", " + n + "%, " + s + "%)";
    var t, r, n, s, i;
  }, e.prototype.toHsv = function() {
    return t = es(this.rgba), { h: G(t.h), s: G(t.s), v: G(t.v), a: G(t.a, 3) };
    var t;
  }, e.prototype.invert = function() {
    return J({ r: 255 - (t = this.rgba).r, g: 255 - t.g, b: 255 - t.b, a: t.a });
    var t;
  }, e.prototype.saturate = function(t) {
    return t === void 0 && (t = 0.1), J(yt(this.rgba, t));
  }, e.prototype.desaturate = function(t) {
    return t === void 0 && (t = 0.1), J(yt(this.rgba, -t));
  }, e.prototype.grayscale = function() {
    return J(yt(this.rgba, -1));
  }, e.prototype.lighten = function(t) {
    return t === void 0 && (t = 0.1), J(zr(this.rgba, t));
  }, e.prototype.darken = function(t) {
    return t === void 0 && (t = 0.1), J(zr(this.rgba, -t));
  }, e.prototype.rotate = function(t) {
    return t === void 0 && (t = 15), this.hue(this.hue() + t);
  }, e.prototype.alpha = function(t) {
    return typeof t == "number" ? J({ r: (r = this.rgba).r, g: r.g, b: r.b, a: t }) : G(this.rgba.a, 3);
    var r;
  }, e.prototype.hue = function(t) {
    var r = we(this.rgba);
    return typeof t == "number" ? J({ h: t, s: r.s, l: r.l, a: r.a }) : G(r.h);
  }, e.prototype.isEqual = function(t) {
    return this.toHex() === J(t).toHex();
  }, e;
}(), J = function(e) {
  return e instanceof Jr ? e : new Jr(e);
};
const De = [
  {
    primaryColor: "--brand-primary",
    colors: [
      { cssVar: "--brand-primary" },
      {
        cssVar: "--brand-primary-hover",
        lightnessMultiplier: 0.86
      },
      {
        cssVar: "--brand-primary-subtle",
        hueDelta: 8,
        saturation: 25,
        lightness: 98
      }
    ]
  },
  {
    primaryColor: "--text-primary",
    colors: [
      { cssVar: "--text-primary" },
      {
        cssVar: "--text-secondary",
        hueDelta: -16,
        saturation: 14,
        lightness: 65
      },
      {
        cssVar: "--text-tertiary",
        hueDelta: -6,
        saturation: 16,
        lightness: 50
      },
      {
        cssVar: "--fill-primary",
        hueDelta: -8,
        saturation: 27,
        lightness: 84
      }
    ]
  },
  {
    primaryColor: "--background-primary",
    colors: [
      { cssVar: "--background-primary" },
      {
        cssVar: "--background-tertiary",
        hueDelta: -4,
        saturation: 16,
        lightness: 93
      },
      {
        cssVar: "--skeleton-primary",
        hueDelta: 19,
        saturation: 8,
        lightness: 81
      }
    ]
  },
  {
    primaryColor: "--background-header",
    colors: [{ cssVar: "--background-header" }]
  }
];
function Fe(e, t) {
  const r = J(e).toRgb(), n = J(e).toHsl(), s = {};
  return t.colors.forEach((i) => {
    if (i.cssVar === t.primaryColor)
      s[i.cssVar] = `${r.r} ${r.g} ${r.b}`;
    else {
      let o = n.h + (i.hueDelta ?? 0);
      o < 0 && (o += 360), o >= 360 && (o -= 360);
      const u = i.saturation !== void 0 ? Math.round(i.saturation) : n.s, c = i.lightness !== void 0 ? Math.round(i.lightness) : i.lightnessMultiplier ? Math.round(n.l * i.lightnessMultiplier) : n.l, l = J({ h: o, s: u, l: c }).toRgb();
      s[i.cssVar] = `${l.r} ${l.g} ${l.b}`;
    }
  }), s;
}
const Wa = (e) => {
  const t = Object.entries(
    Fe(e.oldBrandPrimary, De[0])
  ).map(([i, o]) => `${i}: ${o};`).join(`
`), r = Object.entries(
    Fe(e.oldTextPrimary, De[1])
  ).map(([i, o]) => `${i}: ${o};`).join(`
`), n = Object.entries(
    Fe(e.oldBackgroundPrimary, De[2])
  ).map(([i, o]) => `${i}: ${o};`).join(`
`), s = Object.entries(
    Fe(e.oldBackgroundHeader, De[3])
  ).map(([i, o]) => `${i}: ${o};`).join(`
`);
  return `
        ${[
    t,
    r,
    n,
    s
  ].join(`

`)}
    `;
}, da = "brand_data", $a = () => {
  if (!Ge())
    return;
  const e = localStorage.getItem(da);
  if (e)
    try {
      return JSON.parse(e);
    } catch {
      return;
    }
};
var Ut = /* @__PURE__ */ ((e) => (e.Editor = "editor", e.Community = "community", e.BlockPreview = "block_preview", e.Membership = "membership", e.Marketplace = "marketplace", e.Settings = "settings", e.Email = "email", e.Ckeditor = "ckeditor", e.TextEditor = "text_editor", e.BlogPost = "blog_post", e.PageTemplate = "page_template", e.PageTemplatePreview = "page_template_preview", e.BlogTemplatePreview = "blog_template_preview", e.EmailTemplate = "email_template", e.WebsiteTemplate = "website_template", e.Product = "product", e.FunnelTemplatePreview = "funnel_template_preview", e.DigitalStore = "digital_store", e.DigitalProductResource = "digital_product_resource", e.CalendarHostAvatar = "calendar_host_avatar", e.FileManager = "file_manager", e.WhiteLabel = "white_label", e))(Ut || {}), Mt = /* @__PURE__ */ ((e) => (e.Image = "image", e.ImageOther = "image_other", e.Video = "video", e.Audio = "audio", e.Font = "font", e.Document = "document", e))(Mt || {});
const qa = {
  name: "Systeme.io",
  colors: {
    oldBrandPrimary: "#00A0FF",
    oldTextPrimary: "#142D63",
    oldBackgroundPrimary: "#F1F4F8",
    oldBackgroundHeader: "#142D63"
  },
  favicon: {
    id: 0,
    name: "Favicon",
    filename: "Favicon",
    path: "https://d2543nuuc0wvdg.cloudfront.net/images/logo-compact-new.ico",
    thumbnail: null,
    source: Ut.WhiteLabel,
    size: 0,
    type: Mt.Image,
    createdAt: ""
  },
  logo: {
    id: 0,
    name: "Logo",
    filename: "Logo",
    path: "https://d2543nuuc0wvdg.cloudfront.net/images/logo-compact-new.svg",
    thumbnail: null,
    source: Ut.WhiteLabel,
    size: 0,
    type: Mt.Image,
    createdAt: ""
  },
  dashboardHostname: ""
};
export {
  Bs as AbortError,
  Qr as AccessDenied,
  en as BadRequest,
  tn as ConflictError,
  Kr as ErrorWithFields,
  kt as ErrorWithViolations,
  rn as FailedDependency,
  nn as InternalError,
  ga as InvalidTokenError,
  da as LOCAL_STORAGE_BRAND_DATA_ID,
  sn as LockedError,
  Hs as NetworkError,
  Tt as NotFound,
  on as PayloadTooLarge,
  fo as RequestMethodsEnum,
  an as UnauthorizedResponse,
  un as UnprocessableContentError,
  Fe as adjustColorGroup,
  ln as checkAreThereFieldsErrors,
  qa as defaultBrandSettings,
  ja as fixFailedToExecuteRemoveChildOnNode,
  $a as getBrandFromLocalStorage,
  lo as getErrorMapper,
  ka as getPercent,
  Wa as getRootVarsByBrandColors,
  Qn as getTFuncWithNamespace,
  ia as getTICUFuncWithNamespace,
  La as getUseBaseFetch,
  Fa as getUseLocoTranslation,
  ke as httpBaseClient,
  Ge as isClient,
  Ma as isSioHost,
  Ua as isValidUrl,
  Da as methodsWithoutBody,
  De as semanticColorGroups,
  Ia as setupBasicInterceptor,
  jr as toPercent,
  Va as useStorage,
  Ga as useWatch
};
